var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandsBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4625 952.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11{fill:#3c80f6;}.cls-13,.cls-2{fill:none;}.cls-16,.cls-2,.cls-4{stroke:#004fbb;}.cls-11,.cls-13,.cls-16,.cls-2,.cls-4{stroke-linecap:round;}.cls-13,.cls-16,.cls-2,.cls-4{stroke-miterlimit:10;stroke-width:2px;}.cls-3,.cls-4{fill:#004fbb;}.cls-5{fill:#f7efe2;}.cls-6{fill:#e8e8e8;}.cls-7,.cls-8{fill:#a4a4a4;}.cls-7{opacity:0.2;}.cls-8{opacity:0.15;}.cls-9{opacity:0.5;}.cls-10{fill:#b5b5b5;}.cls-11{stroke:#577fef;stroke-linejoin:round;stroke-width:0.25px;}.cls-12,.cls-15{fill:#d7d7d7;}.cls-12{opacity:0.75;}.cls-13{stroke:#fff;}.cls-14{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1317.45,252.76v698.5h82.11l0-651.17c0-.47,0-.93,0-1.4v-29c0-.42,0-.85,0-1.27V247.28c0-1.18.06-2.36.17-3.54l6.27-63.9a7.28,7.28,0,0,0-14.4-2.09l-12.12,62.82-2.36-2.36-11.66-60.46a7.29,7.29,0,0,0-14.41,2.09l6.29,64.07a10,10,0,0,0-19.8,2.69l.25,2.48-1,.18a10,10,0,0,0-19.32,3.5Zm40-7.25Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1317.45,
    y1: 252.76,
    x2: 1317.45,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1379.44,240.57l12.12-62.82a7.28,7.28,0,0,1,7.15-5.9h0a7.28,7.28,0,0,1,7.25,8l-6.27,63.9c-.11,1.18-.17,2.36-.17,3.54l0,704"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1357.46,245.51,1351,179.84a7.28,7.28,0,0,1,7.25-8h0a7.28,7.28,0,0,1,7.16,5.9l11.66,60.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1363.38,334.88a36.18,36.18,0,0,0,36.18-36.19v-29a21.67,21.67,0,0,0-6.36-15.35l-26.48-26.48a5.42,5.42,0,0,0-9.26,3.83v1.87a36.19,36.19,0,0,0,10.59,25.58l6.25,6.25a3.6,3.6,0,0,1-.07,5.19,37.29,37.29,0,0,0-12.11,27.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1355.55,265.11l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.51a8.15,8.15,0,0,0,8.1,7.34h0A8.13,8.13,0,0,0,1355.55,265.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1335.55,272.36l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.51a8.14,8.14,0,0,0,8.1,7.33h0A8.15,8.15,0,0,0,1335.55,272.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1485.46,222.27a7.6,7.6,0,0,0-7.26,5.37l-16.52,53.83h0a10,10,0,0,0-20,0h0a10,10,0,0,0-10-9.92h0a10,10,0,0,0-10,9.92h0l-20.2-68.3a7.51,7.51,0,0,0-14.58,3.58l12.52,63.94h0a36.14,36.14,0,0,0-21.42-6.93h-1.6a5.43,5.43,0,0,0-3.82,9.27l20.63,20.64a21.69,21.69,0,0,1,6.33,14.14l0,11.68V951.26h84.22V284.74a36.18,36.18,0,0,1,.59-6.49l8.57-47A7.59,7.59,0,0,0,1485.46,222.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1461.68,281.47l16.52-53.83a7.6,7.6,0,0,1,7.26-5.37h0a7.59,7.59,0,0,1,7.48,9l-8.57,47a36.18,36.18,0,0,0-.59,6.49V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1399.56,
    y1: 329.5,
    x2: 1399.56,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1421.67,281.47l-20.2-68.3a7.52,7.52,0,0,0-7.21-5.38h0a7.52,7.52,0,0,0-7.37,9l12.52,63.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1435.75,369.38a36.19,36.19,0,0,1-36.19-36.19V319a21.67,21.67,0,0,0-6.36-15.35L1372.57,283a5.43,5.43,0,0,1,3.81-9.27H1378a36.17,36.17,0,0,1,25.72,10.6l13.08,13.07c2.57,2.57,5.25,5,7.94,7.47A37.37,37.37,0,0,1,1437,332.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1443.57,301.06l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.13,8.13,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,1443.57,301.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1423.57,301.06l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.14,8.14,0,0,1,1423.57,301.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2719.57,242.67V951.26h82.12l0-661.26c0-.47,0-.93,0-1.4v-29c0-.43,0-.85,0-1.27V237.19a35,35,0,0,1,.17-3.54l6.27-63.9a7.29,7.29,0,0,0-14.41-2.09l-12.11,62.82-2.36-2.36-11.66-60.46a7.29,7.29,0,0,0-14.41,2.09l6.29,64.07a10,10,0,0,0-19.8,2.69l.25,2.48-1,.18a10,10,0,0,0-19.33,3.5Zm40-7.25Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2719.57,
    y1: 242.67,
    x2: 2719.57,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2781.57,230.48l12.11-62.82a7.3,7.3,0,0,1,7.16-5.91h0a7.29,7.29,0,0,1,7.25,8l-6.27,63.9a35,35,0,0,0-.17,3.54l0,714.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2759.58,235.42l-6.44-65.67a7.29,7.29,0,0,1,7.25-8h0a7.3,7.3,0,0,1,7.16,5.91l11.66,60.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2765.5,324.78a36.18,36.18,0,0,0,36.19-36.18v-29a21.75,21.75,0,0,0-6.36-15.36l-26.48-26.48a5.43,5.43,0,0,0-9.27,3.84v1.86a36.22,36.22,0,0,0,10.6,25.59l6.25,6.24a3.6,3.6,0,0,1-.08,5.19,37.34,37.34,0,0,0-12.1,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2757.68,255l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-9.95,11l1.85,18.51a8.15,8.15,0,0,0,8.1,7.33h0A8.14,8.14,0,0,0,2757.68,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2737.68,262.26l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.86,18.51a8.12,8.12,0,0,0,8.1,7.33h0A8.14,8.14,0,0,0,2737.68,262.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2965.91,292.7V951.26H3048L3048,340c0-.47,0-.93,0-1.4v-29c0-.42,0-.85,0-1.27V287.22c0-1.18.06-2.36.17-3.54l6.27-63.9a7.28,7.28,0,0,0-14.4-2.09l-12.12,62.82-2.36-2.36-11.66-60.46a7.29,7.29,0,0,0-14.41,2.09l6.29,64.07a10,10,0,0,0-19.8,2.69l.25,2.48-1,.18a10,10,0,0,0-19.32,3.5Zm40-7.25Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2965.91,
    y1: 292.7,
    x2: 2965.91,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3027.9,280.51,3040,217.69a7.28,7.28,0,0,1,7.15-5.9h0a7.28,7.28,0,0,1,7.25,8l-6.27,63.9c-.11,1.18-.17,2.36-.17,3.54l0,664"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3005.91,285.45l-6.44-65.67a7.28,7.28,0,0,1,7.25-8h0a7.29,7.29,0,0,1,7.16,5.9l11.66,60.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3011.84,374.82A36.18,36.18,0,0,0,3048,338.63v-29a21.71,21.71,0,0,0-6.36-15.35l-26.48-26.48a5.43,5.43,0,0,0-9.27,3.83v1.87a36.2,36.2,0,0,0,10.6,25.58l6.25,6.25a3.59,3.59,0,0,1-.08,5.19,37.32,37.32,0,0,0-12.1,27.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3004,305.05l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-9.95,11l1.85,18.51a8.15,8.15,0,0,0,8.1,7.34h0A8.14,8.14,0,0,0,3004,305.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2984,312.3l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-9.95,11l1.85,18.51a8.14,8.14,0,0,0,8.1,7.33h0A8.15,8.15,0,0,0,2984,312.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2881.69,261a10,10,0,0,0-20-.73h-.11l.54-5.43a10,10,0,0,0-9.95-11h0a10,10,0,0,0-9.74,7.72h0a35.88,35.88,0,0,0,1.36-9.76v-1.86a5.43,5.43,0,0,0-9.27-3.84l-15,15h-.15a10,10,0,0,0-7.71-3.62h0a10,10,0,0,0-10,10.95v18.19c0,.44,0,.88,0,1.32v29c0,.52,0,1,0,1.54l0,642.81h80V261Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2881.69,
    y1: 260.99,
    x2: 2881.69,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2801.74,
    y1: 258.09,
    x2: 2801.69,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2837.88,343.1a36.19,36.19,0,0,1-36.19-36.19v-29a21.71,21.71,0,0,1,6.36-15.35l26.48-26.48a5.43,5.43,0,0,1,9.27,3.84v1.86a36.16,36.16,0,0,1-10.6,25.58l-6.24,6.25a3.59,3.59,0,0,0,.07,5.19,37.33,37.33,0,0,1,12.1,27.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2803,270.61l-1.22-12.16a10,10,0,0,1,10-11h0a10,10,0,0,1,7.71,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2841.71,253.73a8.17,8.17,0,0,1-.05,1.1l-1.85,18.51a8.14,8.14,0,0,1-8.1,7.33h0a8.13,8.13,0,0,1-3.71-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2863.59,280.58l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.13,8.13,0,0,1,2863.59,280.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2844.11,273.34l-1.85-18.51a10,10,0,0,1,9.95-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.14,8.14,0,0,1,2844.11,273.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3133.92,152.37a7.59,7.59,0,0,0-7.26,5.37l-16.53,53.83h0a10,10,0,0,0-20,0h0a10,10,0,0,0-10-9.91h0a10,10,0,0,0-10,9.91h0l-20.2-68.29a7.51,7.51,0,0,0-14.58,3.57l12.52,64h0a36.17,36.17,0,0,0-21.42-6.93h-1.61a5.42,5.42,0,0,0-3.81,9.26l20.63,20.64a21.73,21.73,0,0,1,6.33,14.15l0,11.68V951.26h84.22V214.85a35.48,35.48,0,0,1,.59-6.5l8.57-47A7.6,7.6,0,0,0,3133.92,152.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3110.13,211.57l16.53-53.83a7.59,7.59,0,0,1,7.26-5.37h0a7.6,7.6,0,0,1,7.48,9l-8.57,47a35.48,35.48,0,0,0-.59,6.5V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3048.02,
    y1: 259.61,
    x2: 3048.02,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3070.13,211.57l-20.2-68.29a7.52,7.52,0,0,0-7.21-5.38h0a7.51,7.51,0,0,0-7.37,8.95l12.52,64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3084.21,299.48A36.19,36.19,0,0,1,3048,263.29V249.13a21.68,21.68,0,0,0-6.36-15.35L3021,213.14a5.42,5.42,0,0,1,3.81-9.26h1.61a36.21,36.21,0,0,1,25.72,10.6l13.08,13.08c2.57,2.57,5.24,5,7.94,7.47a37.35,37.35,0,0,1,12.28,27.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3092,231.17l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.13,8.13,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,3092,231.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3072,231.17l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.14,8.14,0,0,1,3072,231.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2967.59,176.23a7.61,7.61,0,0,0-7.27,5.37l-16.52,53.83h0a10,10,0,0,0-19.64-2.53l-.74-.09a11.4,11.4,0,0,0-.51-1.42,36.17,36.17,0,0,0,.89-7.93V221.6a5.43,5.43,0,0,0-9.27-3.84l-12.32,12.32h0l-18.62-63a7.51,7.51,0,0,0-14.57,3.58L2881,232a36.89,36.89,0,0,1,.67,7V951.26h84.22V238.7a36.17,36.17,0,0,1,.58-6.49l8.58-47A7.59,7.59,0,0,0,2967.59,176.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2943.8,235.43l16.52-53.83a7.61,7.61,0,0,1,7.27-5.37h0a7.6,7.6,0,0,1,7.48,9l-8.58,47a36.17,36.17,0,0,0-.58,6.49V951.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2902.21,230.08l-18.62-63a7.5,7.5,0,0,0-7.2-5.38h0a7.51,7.51,0,0,0-7.37,9L2881,232a36.89,36.89,0,0,1,.67,7V951.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2917.88,324.78a36.18,36.18,0,0,1-36.19-36.18v-29a21.75,21.75,0,0,1,6.36-15.36l26.48-26.48a5.43,5.43,0,0,1,9.27,3.84v1.86a36.18,36.18,0,0,1-10.6,25.59l-6.25,6.24a3.6,3.6,0,0,0,.08,5.19,37.34,37.34,0,0,1,12.1,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2925.7,255l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11L2941.9,255a8.15,8.15,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,2925.7,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2922.89,231.35a9.94,9.94,0,0,1,.86,5.16L2921.9,255a8.15,8.15,0,0,1-8.1,7.33h0a8.13,8.13,0,0,1-7.74-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.17,183.46a7.32,7.32,0,0,1,7.07,5.45l12.06,46a.07.07,0,0,0,.14,0l-.73-58.29a7.47,7.47,0,0,1,7.47-7.56h0a7.47,7.47,0,0,1,7.39,6.41l8.53,59.34a.07.07,0,0,0,.14,0l4.23-66.1a7.34,7.34,0,0,1,14.67.26L146,234.83a.07.07,0,0,0,.14,0l13-60.13a7.25,7.25,0,0,1,7.09-5.72h0a7.25,7.25,0,0,1,7.2,8.12l-6.82,56.14a35.48,35.48,0,0,0-.27,4.37v2.22a36.2,36.2,0,0,1,21.56-7h1.61a5.42,5.42,0,0,1,3.82,9.26l-20.64,20.64a21.71,21.71,0,0,0-6.36,15.35v14.16h0v659H82.12V238a35.77,35.77,0,0,0-.36-5.06L76,191.79A7.3,7.3,0,0,1,83.17,183.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.33,239.82v-2.2a35.48,35.48,0,0,1,.27-4.37l6.82-56.14a7.25,7.25,0,0,0-7.2-8.12h0a7.25,7.25,0,0,0-7.09,5.72l-13,60.13a.07.07,0,0,1-.14,0l-1.85-65.94a7.35,7.35,0,0,0-7.34-7.14h0a7.34,7.34,0,0,0-7.33,6.88l-4.23,66.1a.07.07,0,0,1-.14,0l-8.53-59.34a7.47,7.47,0,0,0-7.39-6.41h0a7.47,7.47,0,0,0-7.47,7.56l.73,58.29a.07.07,0,0,1-.14,0l-12.06-46a7.32,7.32,0,0,0-7.07-5.45h0A7.3,7.3,0,0,0,76,191.79l5.81,41.12a35.77,35.77,0,0,1,.36,5.06V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 166.33,
    y1: 951.26,
    x2: 166.33,
    y2: 292.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.15,328.42a36.18,36.18,0,0,0,36.18-36.19V278.07a21.71,21.71,0,0,1,6.36-15.35l20.64-20.64a5.42,5.42,0,0,0-3.82-9.26H187.9a36.17,36.17,0,0,0-25.71,10.6l-13.08,13.08c-2.57,2.57-5.25,5-7.94,7.47a37.35,37.35,0,0,0-12.28,27.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.14,152h0a7.61,7.61,0,0,0-7.27,5.37l-16.52,53.83h0a10,10,0,0,0-10-9.91h0a10,10,0,0,0-10,11l.28,2.82-2.32.46-.32-2a10,10,0,1,0-19.22,5.15l.24.65-1.65.33a10,10,0,0,0-14.12-4.55h0a10,10,0,0,0-3.12,14.5l1,1.42-12-6.95a36.2,36.2,0,0,0-27.59-3.58L126,221a5.43,5.43,0,0,0-1.29,9.94L150,245.49a21.71,21.71,0,0,1,10.12,13.18l3.66,13.68a36.2,36.2,0,0,0,2.56,6.78h0V951.26h82.12V214.46A36.27,36.27,0,0,1,249,208l8.58-47A7.61,7.61,0,0,0,250.14,152Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.35,211.19l16.52-53.83a7.61,7.61,0,0,1,7.27-5.37h0a7.61,7.61,0,0,1,7.48,9L249,208a36.27,36.27,0,0,0-.59,6.49v736.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 166.33,
    y1: 279.13,
    x2: 166.33,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.09,297.94a36.19,36.19,0,0,1-44.32-25.59l-3.66-13.68A21.71,21.71,0,0,0,150,245.49L124.71,230.9A5.43,5.43,0,0,1,126,221l1.55-.42a36.2,36.2,0,0,1,27.59,3.58l14,8.1c3,1.73,7.9,4.49,11,6a37.35,37.35,0,0,1,19.63,23.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.24,230.78l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11l-1.85,18.51a8.14,8.14,0,0,1-8.11,7.33h0A8.14,8.14,0,0,1,208.24,230.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.38,236.12l-6.57-17.4a10,10,0,0,1,6.76-13.19h0a10,10,0,0,1,12.46,8l3,18.36a8.13,8.13,0,0,1-5.92,9.18h0A8.15,8.15,0,0,1,191.38,236.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.18,231.07l-1-1.42a10,10,0,0,1,3.12-14.5h0a10,10,0,0,1,14.12,4.55l7.65,17a8.14,8.14,0,0,1-1.05,8.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M574.73,242.67a10,10,0,0,0-20-.72h-.11l.54-5.43a10,10,0,0,0-10-11h0a10,10,0,0,0-9.74,7.73h0a36.34,36.34,0,0,0,1.35-9.77V221.6a5.43,5.43,0,0,0-9.27-3.84l-15,15-.15,0a10,10,0,0,0-7.71-3.62h0a10,10,0,0,0-10,10.94v18.2c0,.43,0,.87,0,1.32v29c0,.51,0,1,0,1.53l0,661.13h80V242.67Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 574.73,
    y1: 242.67,
    x2: 574.73,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 494.78,
    y1: 239.77,
    x2: 494.73,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M530.92,324.78a36.18,36.18,0,0,1-36.19-36.18v-29a21.75,21.75,0,0,1,6.36-15.36l26.48-26.48a5.43,5.43,0,0,1,9.27,3.84v1.86a36.18,36.18,0,0,1-10.6,25.59L520,255.29a3.59,3.59,0,0,0,.07,5.19,37.35,37.35,0,0,1,12.11,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M496,252.29l-1.22-12.16a10,10,0,0,1,10-11h0a10,10,0,0,1,7.71,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M534.76,235.42c0,.36,0,.72,0,1.09L532.85,255a8.13,8.13,0,0,1-8.1,7.33h0a8.12,8.12,0,0,1-3.71-.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M556.63,262.26l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.34h0A8.14,8.14,0,0,1,556.63,262.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M537.15,255l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11L553.35,255a8.14,8.14,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,537.15,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.61,219.65a7.3,7.3,0,0,0-7.06,5.45L312.48,271a.07.07,0,0,1-.14,0l.73-58.28a7.46,7.46,0,0,0-7.46-7.56h0a7.46,7.46,0,0,0-7.4,6.4l-8.52,59.34a.08.08,0,0,1-.15,0l-4.22-66.1a7.35,7.35,0,0,0-14.68.26L268.8,271a.08.08,0,0,1-.15,0l-13-60.14a7.25,7.25,0,0,0-7.09-5.71h0a7.24,7.24,0,0,0-7.19,8.12l6.82,56.14a37.5,37.5,0,0,1,.26,4.36V276a36.14,36.14,0,0,0-21.56-7h-1.61a5.43,5.43,0,0,0-3.82,9.27l20.64,20.64a21.71,21.71,0,0,1,6.36,15.35v14.16h0V951.26h84.22V274.16a35.8,35.8,0,0,1,.35-5.07L338.84,228A7.3,7.3,0,0,0,331.61,219.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.45,276V273.8a37.5,37.5,0,0,0-.26-4.36l-6.82-56.14a7.24,7.24,0,0,1,7.19-8.12h0a7.25,7.25,0,0,1,7.09,5.71l13,60.14a.08.08,0,0,0,.15,0l1.84-65.94a7.35,7.35,0,0,1,7.35-7.14h0a7.35,7.35,0,0,1,7.33,6.88l4.22,66.1a.08.08,0,0,0,.15,0l8.52-59.34a7.46,7.46,0,0,1,7.4-6.4h0a7.46,7.46,0,0,1,7.46,7.56L312.34,271a.07.07,0,0,0,.14,0l12.07-45.94a7.3,7.3,0,0,1,7.06-5.45h0a7.3,7.3,0,0,1,7.23,8.32L333,269.09a35.81,35.81,0,0,0-.36,5.07v677.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 248.45,
    y1: 951.26,
    x2: 248.45,
    y2: 328.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.64,364.61a36.19,36.19,0,0,1-36.19-36.19V314.26a21.71,21.71,0,0,0-6.36-15.35l-20.64-20.64a5.43,5.43,0,0,1,3.82-9.27h1.61a36.17,36.17,0,0,1,25.72,10.6l13.07,13.07c2.57,2.57,5.25,5,7.94,7.47a37.33,37.33,0,0,1,12.28,27.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.12,242.67a10,10,0,0,0-19-4.25l-1.21-.27.16-1.64a10,10,0,0,0-19.79-2.74l-.33-.07a10,10,0,0,0-.72-2.31,36.17,36.17,0,0,0,.89-7.93V221.6a5.43,5.43,0,0,0-9.27-3.84L21.48,229.13h0l-6-60.41a7.74,7.74,0,0,0-7.7-7h0a7.73,7.73,0,0,0-7.73,7.73l0,88.81c0,.43,0,.87,0,1.31v29c0,.5,0,1,0,1.51L0,951.26H82.12V242.67Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 82.12,
    y1: 242.67,
    x2: 82.12,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44,255l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11L60.21,255a8.15,8.15,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,44,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.2,231.35a9.94,9.94,0,0,1,.86,5.16L40.21,255a8.15,8.15,0,0,1-8.1,7.33h0a8.13,8.13,0,0,1-7.74-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64,262.26l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11l-1.85,18.51a8.15,8.15,0,0,1-8.11,7.34h0A8.15,8.15,0,0,1,64,262.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M494.73,242.67a10,10,0,0,0-19-4.25l-1.21-.27.17-1.64a10,10,0,0,0-19.79-2.74l-.33-.07a10,10,0,0,0-.73-2.31,36.17,36.17,0,0,0,.89-7.93V221.6a5.42,5.42,0,0,0-9.26-3.84l-11.37,11.37h0l-6-60.41a7.73,7.73,0,0,0-7.69-7h0a7.73,7.73,0,0,0-7.73,7.73l0,88.81c0,.43,0,.87,0,1.31v29c0,.5,0,1,0,1.51l0,661.15h82.11V242.67Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 494.73,
    y1: 242.67,
    x2: 494.73,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.09,229.13l-6-60.41a7.73,7.73,0,0,0-7.69-7h0a7.73,7.73,0,0,0-7.73,7.73l-.06,781.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M448.8,324.78a36.18,36.18,0,0,1-36.18-36.18v-29A21.74,21.74,0,0,1,419,244.24l26.49-26.48a5.42,5.42,0,0,1,9.26,3.84v1.86a36.18,36.18,0,0,1-10.6,25.59l-6.24,6.24a3.6,3.6,0,0,0,.07,5.19,37.35,37.35,0,0,1,12.11,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M456.62,255l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11L472.83,255a8.15,8.15,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,456.62,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M453.82,231.35a9.94,9.94,0,0,1,.85,5.16L452.82,255a8.14,8.14,0,0,1-8.1,7.33h0a8.15,8.15,0,0,1-7.74-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M476.63,262.26l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.34h0A8.15,8.15,0,0,1,476.63,262.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3883.6,183.46a7.31,7.31,0,0,0-7.06,5.45l-12.06,46a.07.07,0,0,1-.14,0l.73-58.29a7.47,7.47,0,0,0-7.47-7.56h0a7.47,7.47,0,0,0-7.39,6.41l-8.53,59.34a.07.07,0,0,1-.14,0l-4.23-66.1a7.34,7.34,0,0,0-14.67.26l-1.85,65.94a.07.07,0,0,1-.14,0l-13-60.13a7.25,7.25,0,0,0-7.09-5.72h0a7.25,7.25,0,0,0-7.2,8.12l6.82,56.14a35.48,35.48,0,0,1,.27,4.37v2.2l0,0a36.18,36.18,0,0,0-21.56-7h-1.6a5.42,5.42,0,0,0-3.82,9.26l20.64,20.64a21.71,21.71,0,0,1,6.36,15.35v14.16h0v659h84.21V238a35.77,35.77,0,0,1,.36-5.06l5.81-41.12A7.31,7.31,0,0,0,3883.6,183.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3800.45,239.82v-2.2a35.48,35.48,0,0,0-.27-4.37l-6.82-56.14a7.25,7.25,0,0,1,7.2-8.12h0a7.25,7.25,0,0,1,7.09,5.72l13,60.13a.07.07,0,0,0,.14,0l1.85-65.94a7.34,7.34,0,0,1,7.34-7.14h0a7.34,7.34,0,0,1,7.33,6.88l4.23,66.1a.07.07,0,0,0,.14,0l8.53-59.34a7.47,7.47,0,0,1,7.39-6.41h0a7.47,7.47,0,0,1,7.47,7.56l-.73,58.29a.07.07,0,0,0,.14,0l12.06-46a7.31,7.31,0,0,1,7.06-5.45h0a7.31,7.31,0,0,1,7.23,8.33L3885,232.91a35.77,35.77,0,0,0-.36,5.06V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3800.45,
    y1: 951.26,
    x2: 3800.45,
    y2: 292.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3836.63,328.42a36.18,36.18,0,0,1-36.18-36.19V278.07a21.71,21.71,0,0,0-6.36-15.35l-20.64-20.64a5.42,5.42,0,0,1,3.82-9.26h1.6a36.19,36.19,0,0,1,25.72,10.6l13.08,13.08c2.57,2.57,5.25,5,7.94,7.47a37.35,37.35,0,0,1,12.28,27.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3884.66,262.55a10,10,0,0,1,19-4.25l1.21-.27-.16-1.64a10,10,0,0,1,19.79-2.74l.33-.08a10.08,10.08,0,0,1,.72-2.3,36.24,36.24,0,0,1-.89-7.93v-1.86a5.43,5.43,0,0,1,9.27-3.84L3945.3,249h0l6-60.4a7.73,7.73,0,0,1,7.69-7h0a7.74,7.74,0,0,1,7.74,7.73v88.8c0,.44.05.88.05,1.31v29c0,.51,0,1,0,1.51l0,641.28h-82.12V262.55Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3884.66,
    y1: 262.55,
    x2: 3884.66,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3945.3,249l6-60.4a7.73,7.73,0,0,1,7.69-7h0a7.74,7.74,0,0,1,7.74,7.73l.06,761.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3930.59,344.66a36.19,36.19,0,0,0,36.19-36.19v-29a21.73,21.73,0,0,0-6.36-15.35l-26.48-26.48a5.43,5.43,0,0,0-9.27,3.84v1.86a36.18,36.18,0,0,0,10.6,25.59l6.24,6.24a3.59,3.59,0,0,1-.07,5.19,37.35,37.35,0,0,0-12.11,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3922.77,274.9l1.85-18.51a10,10,0,0,0-9.95-11h0a10,10,0,0,0-10,11l1.85,18.51a8.14,8.14,0,0,0,8.1,7.33h0A8.15,8.15,0,0,0,3922.77,274.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3925.58,251.23a9.92,9.92,0,0,0-.86,5.16l1.85,18.51a8.15,8.15,0,0,0,8.1,7.33h0a8.14,8.14,0,0,0,7.74-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3902.76,282.14l1.86-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-9.95,11l1.85,18.51a8.15,8.15,0,0,0,8.1,7.33h0A8.13,8.13,0,0,0,3902.76,282.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4048.89,278.86a10,10,0,0,0-19.32-3.51l-1-.17.25-2.48A10,10,0,0,0,4009,270l6.29-64.06a7.29,7.29,0,0,0-14.41-2.1l-11.66,60.47-2.36,2.36-12.11-62.83a7.29,7.29,0,0,0-14.41,2.1l6.27,63.9a34.81,34.81,0,0,1,.17,3.54v21.14c0,.42,0,.84,0,1.26v29c0,.47,0,.94,0,1.4l0,625.08h82.12V278.86Zm-40-7.27h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4048.9,
    y1: 278.86,
    x2: 4048.9,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3986.9,266.67l-12.11-62.83a7.3,7.3,0,0,0-7.16-5.9h0a7.29,7.29,0,0,0-7.25,8l6.27,63.9a34.81,34.81,0,0,1,.17,3.54l0,677.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4008.89,271.6l6.44-65.66a7.29,7.29,0,0,0-7.25-8h0a7.3,7.3,0,0,0-7.16,5.9l-11.66,60.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4003,361a36.18,36.18,0,0,1-36.18-36.19v-29a21.73,21.73,0,0,1,6.36-15.35L3999.62,254a5.43,5.43,0,0,1,9.27,3.84v1.86a36.22,36.22,0,0,1-10.6,25.59l-6.25,6.24a3.6,3.6,0,0,0,.08,5.19,37.33,37.33,0,0,1,12.1,27.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4010.79,291.21l-1.85-18.51a10,10,0,0,1,9.95-11h0a10,10,0,0,1,10,11L4027,291.21a8.15,8.15,0,0,1-8.1,7.33h0A8.14,8.14,0,0,1,4010.79,291.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4030.79,298.45l-1.85-18.51a10,10,0,0,1,9.95-11h0a10,10,0,0,1,10,11L4047,298.45a8.13,8.13,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,4030.79,298.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.67,278.86a10,10,0,0,1,20-.73h.11l-.55-5.43a10,10,0,0,1,10-11h0a10,10,0,0,1,9.73,7.72h0a36.4,36.4,0,0,1-1.35-9.77v-1.86a5.42,5.42,0,0,1,9.26-3.84l15,15H395a10,10,0,0,1,7.7-3.62h0a10,10,0,0,1,10,10.95v18.19c0,.44,0,.88,0,1.32v29c0,.52,0,1,0,1.54l0,624.94h-80V278.86Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 332.67,
    y1: 278.86,
    x2: 332.67,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 412.62,
    y1: 275.96,
    x2: 412.66,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.48,361a36.18,36.18,0,0,0,36.18-36.19v-29a21.68,21.68,0,0,0-6.36-15.35L379.82,254a5.42,5.42,0,0,0-9.26,3.84v1.86a36.21,36.21,0,0,0,10.59,25.59l6.25,6.24a3.6,3.6,0,0,1-.07,5.19,37.31,37.31,0,0,0-12.11,27.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M411.4,288.48l1.21-12.16a10,10,0,0,0-9.95-11h0a10,10,0,0,0-7.7,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.64,271.6a10.24,10.24,0,0,0,.05,1.1l1.85,18.51a8.15,8.15,0,0,0,8.1,7.33h0a8,8,0,0,0,3.72-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.77,298.45l1.85-18.51a10,10,0,0,0-9.95-11h0a10,10,0,0,0-9.95,11l1.85,18.51a8.13,8.13,0,0,0,8.1,7.33h0A8.15,8.15,0,0,0,350.77,298.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.25,291.21l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.86,18.51a8.13,8.13,0,0,0,8.1,7.33h0A8.15,8.15,0,0,0,370.25,291.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M740,278.86a10,10,0,0,1,20-.73h.11l-.54-5.43a10,10,0,0,1,10-11h0a10,10,0,0,1,9.74,7.72h0a36,36,0,0,1-1.36-9.77v-1.86a5.43,5.43,0,0,1,9.27-3.84l15,15h.16a10,10,0,0,1,7.7-3.62h0a10,10,0,0,1,10,10.95v18.19c0,.44,0,.88,0,1.32v29c0,.52,0,1,0,1.54l0,624.94H740V278.86Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 739.99,
    y1: 278.86,
    x2: 739.99,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 819.94,
    y1: 275.96,
    x2: 819.99,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M783.8,361A36.19,36.19,0,0,0,820,324.78v-29a21.73,21.73,0,0,0-6.36-15.35L787.15,254a5.43,5.43,0,0,0-9.27,3.84v1.86a36.22,36.22,0,0,0,10.6,25.59l6.25,6.24a3.6,3.6,0,0,1-.08,5.19,37.33,37.33,0,0,0-12.1,27.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M818.72,288.48l1.22-12.16a10,10,0,0,0-10-11h0a10,10,0,0,0-7.7,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M780,271.6a8.17,8.17,0,0,0,0,1.1l1.85,18.51a8.14,8.14,0,0,0,8.1,7.33h0a8.08,8.08,0,0,0,3.72-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M758.09,298.45,760,279.94a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.51a8.15,8.15,0,0,0,8.1,7.33h0A8.13,8.13,0,0,0,758.09,298.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M777.57,291.21l1.85-18.51a10,10,0,0,0-9.95-11h0a10,10,0,0,0-10,11l1.85,18.51a8.15,8.15,0,0,0,8.1,7.33h0A8.14,8.14,0,0,0,777.57,291.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4128.89,235.43a10,10,0,0,0-20-.72h-.11l.55-5.44a10,10,0,0,0-10-11h0a10,10,0,0,0-9.74,7.72h0a36.29,36.29,0,0,0,1.35-9.77v-1.86a5.43,5.43,0,0,0-9.26-3.84l-15,15h-.16a10,10,0,0,0-7.7-3.62h0a10,10,0,0,0-10,10.95V251c0,.44,0,.88,0,1.32v29c0,.51,0,1,0,1.53l0,668.37h80V235.43Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4128.89,
    y1: 235.43,
    x2: 4128.89,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4048.94,
    y1: 232.54,
    x2: 4048.9,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4085.08,317.55a36.19,36.19,0,0,1-36.18-36.19v-29a21.7,21.7,0,0,1,6.35-15.35l26.49-26.49a5.43,5.43,0,0,1,9.26,3.84v1.86a36.16,36.16,0,0,1-10.6,25.59l-6.24,6.25a3.59,3.59,0,0,0,.07,5.18,37.33,37.33,0,0,1,12.11,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4050.16,245.05,4049,232.89a10,10,0,0,1,10-11h0a10,10,0,0,1,7.7,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4088.92,228.18a9.94,9.94,0,0,1-.05,1.09L4087,247.78a8.14,8.14,0,0,1-8.1,7.33h0a8.17,8.17,0,0,1-3.72-.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4110.79,255l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11L4127,255a8.14,8.14,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,4110.79,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4091.31,247.78l-1.85-18.51a10,10,0,0,1,9.95-11h0a10,10,0,0,1,10,11l-1.86,18.51a8.12,8.12,0,0,1-8.1,7.33h0A8.14,8.14,0,0,1,4091.31,247.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1483.78,242.67a10,10,0,0,1,19.32-3.5l1-.18-.25-2.48a10,10,0,0,1,19.8-2.69l-6.29-64.07a7.29,7.29,0,0,1,14.41-2.09l11.66,60.46,2.36,2.36,12.12-62.82a7.28,7.28,0,0,1,14.4,2.09l-6.27,63.9c-.11,1.18-.17,2.36-.17,3.54v21.14c0,.42.05.84.05,1.27v29c0,.47,0,.93,0,1.4l0,661.26h-82.12V242.67Zm40-7.26h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1483.78,
    y1: 242.67,
    x2: 1483.78,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1545.77,230.48l12.12-62.82a7.28,7.28,0,0,1,7.15-5.91h0a7.28,7.28,0,0,1,7.25,8l-6.27,63.9c-.11,1.18-.17,2.36-.17,3.54l.05,714.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1523.79,235.42l-6.45-65.67a7.29,7.29,0,0,1,7.26-8h0a7.28,7.28,0,0,1,7.15,5.91l11.66,60.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1529.71,324.78a36.19,36.19,0,0,0,36.19-36.18v-29a21.75,21.75,0,0,0-6.36-15.36l-26.49-26.48a5.42,5.42,0,0,0-9.26,3.84v1.86a36.18,36.18,0,0,0,10.6,25.59l6.24,6.24a3.6,3.6,0,0,1-.07,5.19,37.35,37.35,0,0,0-12.11,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1521.89,255l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.51a8.15,8.15,0,0,0,8.11,7.33h0A8.15,8.15,0,0,0,1521.89,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1501.88,262.26l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.51a8.15,8.15,0,0,0,8.1,7.34h0A8.14,8.14,0,0,0,1501.88,262.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M740,242.67V951.26H657.87l0-661.26c0-.47,0-.93,0-1.4v-29c0-.43,0-.85,0-1.27V237.19c0-1.18-.06-2.36-.17-3.54l-6.27-63.9a7.28,7.28,0,0,1,14.4-2.09L678,230.48l2.36-2.36L692,167.66a7.29,7.29,0,0,1,14.41,2.09l-6.29,64.07a10,10,0,0,1,19.8,2.69l-.25,2.48,1,.18a10,10,0,0,1,19.32,3.5Zm-40-7.25Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 739.99,
    y1: 242.67,
    x2: 739.99,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M678,230.48l-12.12-62.82a7.28,7.28,0,0,0-7.15-5.91h0a7.28,7.28,0,0,0-7.25,8l6.27,63.9c.11,1.18.17,2.36.17,3.54l0,714.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M700,235.42l6.45-65.67a7.29,7.29,0,0,0-7.26-8h0a7.28,7.28,0,0,0-7.15,5.91l-11.66,60.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M694.06,324.78a36.19,36.19,0,0,1-36.19-36.18v-29a21.75,21.75,0,0,1,6.36-15.36l26.49-26.48A5.42,5.42,0,0,1,700,221.6v1.86a36.18,36.18,0,0,1-10.6,25.59l-6.24,6.24a3.6,3.6,0,0,0,.07,5.19,37.35,37.35,0,0,1,12.11,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M701.88,255,700,236.51a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11L718.09,255a8.15,8.15,0,0,1-8.11,7.33h0A8.15,8.15,0,0,1,701.88,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M721.89,262.26,720,243.75a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.34h0A8.14,8.14,0,0,1,721.89,262.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M659.16,234.12a7.6,7.6,0,0,0-7.27,5.38l-16.52,53.83h0a10,10,0,0,0-20,0h0a10,10,0,0,0-10-9.92h0a10,10,0,0,0-10,9.92h0L575.16,225a7.51,7.51,0,0,0-14.57,3.57l12.52,64h0a36.27,36.27,0,0,0-21.42-6.94h-1.61a5.43,5.43,0,0,0-3.82,9.27l20.64,20.63a21.67,21.67,0,0,1,6.32,14.15l0,11.68v609.9h84.21V296.6a36.38,36.38,0,0,1,.59-6.5l8.58-47A7.6,7.6,0,0,0,659.16,234.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M635.37,293.33l16.52-53.83a7.6,7.6,0,0,1,7.27-5.38h0a7.6,7.6,0,0,1,7.48,9l-8.58,47a36.38,36.38,0,0,0-.59,6.5V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 573.26,
    y1: 341.36,
    x2: 573.26,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M595.36,293.33,575.16,225a7.5,7.5,0,0,0-7.2-5.38h0a7.5,7.5,0,0,0-7.37,8.95l12.52,64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M609.44,381.23a36.18,36.18,0,0,1-36.18-36.18V330.89a21.75,21.75,0,0,0-6.36-15.36L546.26,294.9a5.43,5.43,0,0,1,3.82-9.27h1.61a36.21,36.21,0,0,1,25.72,10.6l13.07,13.08c2.57,2.57,5.25,5,7.94,7.47A37.37,37.37,0,0,1,610.7,344.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M617.27,312.92l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.14,8.14,0,0,1,617.27,312.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M597.26,312.92l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11l-1.86,18.51a8.13,8.13,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,597.26,312.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2064.7,203.05a7.3,7.3,0,0,1,7.06,5.45l12.06,45.94a.08.08,0,0,0,.15,0l-.73-58.29a7.46,7.46,0,0,1,7.46-7.56h0a7.47,7.47,0,0,1,7.4,6.4l8.52,59.34a.08.08,0,0,0,.15,0l4.22-66.1a7.35,7.35,0,0,1,14.68.26l1.84,65.94a.08.08,0,0,0,.15,0l13-60.14a7.25,7.25,0,0,1,7.09-5.71h0a7.24,7.24,0,0,1,7.19,8.12l-6.82,56.14a37.5,37.5,0,0,0-.26,4.36v2.23a36.14,36.14,0,0,1,21.56-7H2171a5.43,5.43,0,0,1,3.82,9.27l-20.64,20.64a21.71,21.71,0,0,0-6.36,15.35v14.16h0V951.26h-84.22V257.56a35.9,35.9,0,0,0-.35-5.07l-5.82-41.12A7.3,7.3,0,0,1,2064.7,203.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2147.86,259.41V257.2a37.5,37.5,0,0,1,.26-4.36l6.82-56.14a7.24,7.24,0,0,0-7.19-8.12h0a7.25,7.25,0,0,0-7.09,5.71l-13,60.14a.08.08,0,0,1-.15,0l-1.84-65.94a7.35,7.35,0,0,0-7.35-7.14h0a7.35,7.35,0,0,0-7.33,6.88l-4.22,66.1a.08.08,0,0,1-.15,0L2098.1,195a7.47,7.47,0,0,0-7.4-6.4h0a7.46,7.46,0,0,0-7.46,7.56l.73,58.29a.08.08,0,0,1-.15,0l-12.06-45.94a7.3,7.3,0,0,0-7.06-5.45h0a7.3,7.3,0,0,0-7.23,8.32l5.82,41.12a35.9,35.9,0,0,1,.35,5.07v693.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2147.86,
    y1: 951.26,
    x2: 2147.86,
    y2: 311.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2111.67,348a36.19,36.19,0,0,0,36.19-36.19V297.66a21.71,21.71,0,0,1,6.36-15.35l20.64-20.64a5.43,5.43,0,0,0-3.82-9.27h-1.61a36.17,36.17,0,0,0-25.72,10.6l-13.07,13.07c-2.57,2.57-5.25,5-7.94,7.47a37.33,37.33,0,0,0-12.28,27.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3718.33,278.86v672.4h82.12l0-625.08c0-.46,0-.93,0-1.4v-29c0-.42,0-.84,0-1.26V273.38c0-1.18.06-2.37.17-3.54l6.27-63.9a7.28,7.28,0,0,0-14.4-2.1l-12.12,62.83-2.36-2.36-11.66-60.47a7.29,7.29,0,0,0-14.41,2.1l6.29,64.06a10,10,0,0,0-19.8,2.7l.25,2.48-1,.17a10,10,0,0,0-19.33,3.51Zm40-7.26Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3718.33,
    y1: 278.86,
    x2: 3718.33,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3780.32,266.67l12.12-62.83a7.29,7.29,0,0,1,7.15-5.9h0a7.28,7.28,0,0,1,7.25,8l-6.27,63.9c-.11,1.17-.17,2.36-.17,3.54l0,677.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3758.34,271.6l-6.45-65.66a7.29,7.29,0,0,1,7.26-8h0a7.29,7.29,0,0,1,7.15,5.9L3778,264.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3764.26,361a36.19,36.19,0,0,0,36.19-36.19v-29a21.73,21.73,0,0,0-6.36-15.35L3767.6,254a5.42,5.42,0,0,0-9.26,3.84v1.86a36.18,36.18,0,0,0,10.6,25.59l6.24,6.24a3.6,3.6,0,0,1-.07,5.19A37.34,37.34,0,0,0,3763,324.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3756.44,291.21l1.85-18.51a10,10,0,0,0-9.95-11h0a10,10,0,0,0-10,11l1.86,18.51a8.13,8.13,0,0,0,8.1,7.33h0A8.15,8.15,0,0,0,3756.44,291.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3736.43,298.45l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-9.95,11l1.85,18.51a8.15,8.15,0,0,0,8.1,7.33h0A8.14,8.14,0,0,0,3736.43,298.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2392.09,242.67V951.26h82.12l0-661.26c0-.47,0-.93,0-1.4v-29c0-.43,0-.85,0-1.27V237.19a35,35,0,0,1,.17-3.54l6.27-63.9a7.29,7.29,0,0,0-14.41-2.09l-12.11,62.82-2.36-2.36-11.67-60.46a7.28,7.28,0,0,0-14.4,2.09l6.29,64.07a10,10,0,0,0-19.8,2.69l.25,2.48-1,.18a10,10,0,0,0-19.33,3.5Zm40-7.25Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2392.09,
    y1: 242.67,
    x2: 2392.09,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2454.09,230.48l12.11-62.82a7.29,7.29,0,0,1,7.16-5.91h0a7.29,7.29,0,0,1,7.25,8l-6.27,63.9a35,35,0,0,0-.17,3.54l0,714.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2432.1,235.42l-6.44-65.67a7.29,7.29,0,0,1,7.25-8h0a7.28,7.28,0,0,1,7.15,5.91l11.67,60.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2438,324.78a36.18,36.18,0,0,0,36.19-36.18v-29a21.75,21.75,0,0,0-6.36-15.36l-26.48-26.48a5.43,5.43,0,0,0-9.27,3.84v1.86a36.22,36.22,0,0,0,10.6,25.59l6.25,6.24a3.6,3.6,0,0,1-.08,5.19,37.34,37.34,0,0,0-12.1,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2430.2,255l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-9.95,11L2414,255a8.15,8.15,0,0,0,8.1,7.33h0A8.15,8.15,0,0,0,2430.2,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2410.2,262.26l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.51a8.14,8.14,0,0,0,8.11,7.33h0A8.14,8.14,0,0,0,2410.2,262.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2307.88,221a10,10,0,0,0-20-.72h-.11l.54-5.43a10,10,0,0,0-9.95-11h0a10,10,0,0,0-9.74,7.73h0a36,36,0,0,0,1.36-9.77v-1.86a5.43,5.43,0,0,0-9.27-3.84l-15,15h-.16a10,10,0,0,0-7.7-3.62h0a10,10,0,0,0-10,11v18.19c0,.44,0,.88,0,1.32v29c0,.52,0,1,0,1.54l0,682.84h80V221Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2307.88,
    y1: 220.96,
    x2: 2307.88,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2227.93,
    y1: 218.06,
    x2: 2227.88,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2264.07,303.07a36.19,36.19,0,0,1-36.19-36.19v-29a21.73,21.73,0,0,1,6.36-15.35l26.48-26.48a5.43,5.43,0,0,1,9.27,3.84v1.86a36.22,36.22,0,0,1-10.6,25.59l-6.25,6.24a3.6,3.6,0,0,0,.08,5.19,37.34,37.34,0,0,1,12.1,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2229.15,230.58l-1.22-12.16a10,10,0,0,1,10-11h0a10,10,0,0,1,7.7,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2267.9,213.7a8.1,8.1,0,0,1-.05,1.1L2266,233.31a8.15,8.15,0,0,1-8.1,7.33h0a8.08,8.08,0,0,1-3.72-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2289.77,240.55,2287.92,222a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11L2306,240.55a8.15,8.15,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,2289.77,240.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2270.3,233.31l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.13,8.13,0,0,1,2270.3,233.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3298.57,242.67V951.26h-82.12l0-661.26c0-.47,0-.93,0-1.4v-29c0-.43,0-.85,0-1.27V237.19a35,35,0,0,0-.18-3.54l-6.27-63.9a7.29,7.29,0,0,1,14.41-2.09l12.12,62.82,2.36-2.36,11.66-60.46a7.28,7.28,0,0,1,14.4,2.09l-6.28,64.07a10,10,0,0,1,19.8,2.69l-.25,2.48,1,.18a10,10,0,0,1,19.33,3.5Zm-40-7.25Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3298.57,
    y1: 242.67,
    x2: 3298.57,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3236.58,230.48l-12.12-62.82a7.28,7.28,0,0,0-7.15-5.91h0a7.29,7.29,0,0,0-7.26,8l6.27,63.9a35,35,0,0,1,.18,3.54l-.05,714.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3258.56,235.42l6.44-65.67a7.28,7.28,0,0,0-7.25-8h0a7.28,7.28,0,0,0-7.15,5.91l-11.66,60.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3252.64,324.78a36.18,36.18,0,0,1-36.19-36.18v-29a21.75,21.75,0,0,1,6.36-15.36l26.48-26.48a5.43,5.43,0,0,1,9.27,3.84v1.86a36.18,36.18,0,0,1-10.6,25.59l-6.24,6.24a3.59,3.59,0,0,0,.07,5.19,37.35,37.35,0,0,1,12.11,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3260.46,255l-1.85-18.51a10,10,0,0,1,9.95-11h0a10,10,0,0,1,10,11L3276.66,255a8.13,8.13,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,3260.46,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3280.47,262.26l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.14,8.14,0,0,1-8.1,7.33h0A8.13,8.13,0,0,1,3280.47,262.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2560.11,212.41a7.61,7.61,0,0,0-7.27,5.37l-16.52,53.83h0a10,10,0,0,0-20,0h0a10,10,0,0,0-10-9.91h0a10,10,0,0,0-10,9.91h0l-20.2-68.29a7.51,7.51,0,0,0-14.57,3.57l12.52,63.95h0a36.17,36.17,0,0,0-21.42-6.93H2451a5.43,5.43,0,0,0-3.82,9.26l20.64,20.64a21.67,21.67,0,0,1,6.32,14.15l0,11.68V951.26h84.22V274.89a36.37,36.37,0,0,1,.58-6.5l8.58-47A7.6,7.6,0,0,0,2560.11,212.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2536.32,271.61l16.52-53.83a7.61,7.61,0,0,1,7.27-5.37h0a7.6,7.6,0,0,1,7.48,9l-8.58,47a36.37,36.37,0,0,0-.58,6.5V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2474.21,
    y1: 319.65,
    x2: 2474.21,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2496.31,271.61l-20.2-68.29a7.5,7.5,0,0,0-7.2-5.38h0a7.5,7.5,0,0,0-7.37,8.95l12.52,63.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2510.4,359.52a36.19,36.19,0,0,1-36.19-36.19V309.17a21.73,21.73,0,0,0-6.36-15.35l-20.64-20.64a5.43,5.43,0,0,1,3.82-9.26h1.61a36.21,36.21,0,0,1,25.72,10.6l13.07,13.08c2.57,2.57,5.25,5,7.94,7.47a37.32,37.32,0,0,1,12.28,27.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2518.22,291.21l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,2518.22,291.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2498.21,291.21l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,2498.21,291.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2229.57,160h0a7.61,7.61,0,0,0-7.27,5.37l-16.52,53.83h0a10,10,0,0,0-10-9.91h0a10,10,0,0,0-9.95,11l.28,2.82-2.32.46-.32-2a10,10,0,1,0-19.22,5.15l.24.65-1.65.33a10,10,0,0,0-14.12-4.55h0a10,10,0,0,0-3.12,14.5l1,1.42-12-7a36.2,36.2,0,0,0-27.59-3.58l-1.55.42a5.43,5.43,0,0,0-1.29,9.94l25.28,14.59a21.69,21.69,0,0,1,10.11,13.18l3.67,13.68a36.2,36.2,0,0,0,2.56,6.78h0V951.26h82.12V222.49a36.29,36.29,0,0,1,.59-6.5l8.58-47A7.61,7.61,0,0,0,2229.57,160Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2205.78,219.21l16.52-53.83a7.61,7.61,0,0,1,7.27-5.37h0a7.61,7.61,0,0,1,7.48,9l-8.58,47a36.29,36.29,0,0,0-.59,6.5V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2145.76,
    y1: 287.15,
    x2: 2145.76,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2187.52,306a36.18,36.18,0,0,1-44.32-25.59l-3.67-13.68a21.69,21.69,0,0,0-10.11-13.18l-25.28-14.59a5.43,5.43,0,0,1,1.29-9.94l1.55-.42a36.2,36.2,0,0,1,27.59,3.58l14,8.1c3,1.73,7.9,4.49,11,6a37.35,37.35,0,0,1,19.63,23.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2187.67,238.8l-1.85-18.51a10,10,0,0,1,9.95-11h0a10,10,0,0,1,10,11l-1.86,18.51a8.13,8.13,0,0,1-8.1,7.34h0A8.15,8.15,0,0,1,2187.67,238.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2170.81,244.14l-6.57-17.4a10,10,0,0,1,6.76-13.19h0a10,10,0,0,1,12.46,8l3,18.36a8.13,8.13,0,0,1-5.92,9.18h0A8.15,8.15,0,0,1,2170.81,244.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2146.61,239.09l-1-1.42a10,10,0,0,1,3.12-14.5h0a10,10,0,0,1,14.12,4.55l7.65,17a8.16,8.16,0,0,1-1.05,8.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4294.19,253a7.31,7.31,0,0,1,7.06,5.44l12.06,45.95a.07.07,0,0,0,.14,0l-.73-58.29a7.47,7.47,0,0,1,7.47-7.56h0a7.47,7.47,0,0,1,7.39,6.41l8.53,59.34a.07.07,0,0,0,.14,0l4.23-66.1a7.34,7.34,0,0,1,14.67.26l1.85,65.94a.07.07,0,0,0,.14,0l13-60.14a7.25,7.25,0,0,1,7.09-5.72h0a7.26,7.26,0,0,1,7.2,8.13l-6.82,56.14a35.2,35.2,0,0,0-.27,4.36v2.21h0a36.18,36.18,0,0,1,21.56-7h1.6a5.43,5.43,0,0,1,3.82,9.27l-20.64,20.63a21.73,21.73,0,0,0-6.36,15.35v14.17h0V951.26h-84.21V307.49a35.81,35.81,0,0,0-.36-5.07L4287,261.3A7.3,7.3,0,0,1,4294.19,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4377.34,309.33v-2.2a35.2,35.2,0,0,1,.27-4.36l6.82-56.14a7.26,7.26,0,0,0-7.2-8.13h0a7.25,7.25,0,0,0-7.09,5.72l-13,60.14a.07.07,0,0,1-.14,0l-1.85-65.94a7.34,7.34,0,0,0-7.34-7.14h0a7.34,7.34,0,0,0-7.33,6.88l-4.23,66.1a.07.07,0,0,1-.14,0l-8.53-59.34a7.47,7.47,0,0,0-7.39-6.41h0a7.47,7.47,0,0,0-7.47,7.56l.73,58.29a.07.07,0,0,1-.14,0l-12.06-45.95a7.31,7.31,0,0,0-7.06-5.44h0a7.3,7.3,0,0,0-7.23,8.32l5.81,41.12a35.81,35.81,0,0,1,.36,5.07V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4377.34,
    y1: 951.26,
    x2: 4377.34,
    y2: 361.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4341.16,397.93a36.18,36.18,0,0,0,36.18-36.18V347.58a21.73,21.73,0,0,1,6.36-15.35l20.64-20.64a5.42,5.42,0,0,0-3.82-9.26h-1.6a36.19,36.19,0,0,0-25.72,10.6L4360.12,326c-2.57,2.57-5.25,5-7.94,7.47a37.35,37.35,0,0,0-12.28,27.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4211,278.86v672.4h82.12l0-625.08c0-.46,0-.93,0-1.4v-29c0-.42,0-.84,0-1.26V273.38a34.82,34.82,0,0,1,.18-3.54l6.27-63.9a7.29,7.29,0,0,0-14.41-2.1L4273,266.67l-2.35-2.36L4259,203.84a7.28,7.28,0,0,0-14.4,2.1l6.28,64.06a10,10,0,0,0-19.79,2.7l.24,2.48-1,.17a10,10,0,0,0-19.33,3.51Zm40-7.26Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4211.01,
    y1: 278.86,
    x2: 4211.01,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4273,266.67l12.12-62.83a7.29,7.29,0,0,1,7.16-5.9h0a7.29,7.29,0,0,1,7.25,8l-6.27,63.9a34.82,34.82,0,0,0-.18,3.54l.05,677.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4251,271.6l-6.44-65.66a7.28,7.28,0,0,1,7.25-8h0a7.29,7.29,0,0,1,7.15,5.9l11.67,60.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4256.94,361a36.19,36.19,0,0,0,36.19-36.19v-29a21.73,21.73,0,0,0-6.36-15.35L4260.29,254a5.43,5.43,0,0,0-9.27,3.84v1.86a36.18,36.18,0,0,0,10.6,25.59l6.24,6.24a3.59,3.59,0,0,1-.07,5.19,37.33,37.33,0,0,0-12.1,27.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4249.12,291.21,4251,272.7a10,10,0,0,0-9.95-11h0a10,10,0,0,0-10,11l1.85,18.51a8.14,8.14,0,0,0,8.1,7.33h0A8.15,8.15,0,0,0,4249.12,291.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4229.11,298.45l1.86-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-9.95,11l1.85,18.51a8.15,8.15,0,0,0,8.1,7.33h0A8.13,8.13,0,0,0,4229.11,298.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4539.46,221a10,10,0,0,0-20-.72h-.11l.54-5.43a10,10,0,0,0-10-11h0a10,10,0,0,0-9.74,7.73h0a36,36,0,0,0,1.36-9.77v-1.86a5.43,5.43,0,0,0-9.27-3.84l-15,15h-.15a10,10,0,0,0-7.71-3.62h0a10,10,0,0,0-9.95,11v18.19c0,.44-.05.88-.05,1.32v29c0,.52,0,1,0,1.54l0,682.84h80V221Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4539.46,
    y1: 220.96,
    x2: 4539.46,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4459.51,
    y1: 218.06,
    x2: 4459.46,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4495.65,303.07a36.19,36.19,0,0,1-36.19-36.19v-29a21.73,21.73,0,0,1,6.36-15.35l26.48-26.48a5.43,5.43,0,0,1,9.27,3.84v1.86a36.18,36.18,0,0,1-10.6,25.59l-6.24,6.24a3.59,3.59,0,0,0,.07,5.19,37.34,37.34,0,0,1,12.1,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4460.73,230.58l-1.22-12.16a10,10,0,0,1,9.95-11h0a10,10,0,0,1,7.71,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4499.48,213.7a8.1,8.1,0,0,1,0,1.1l-1.85,18.51a8.14,8.14,0,0,1-8.1,7.33h0a8,8,0,0,1-3.71-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4521.36,240.55,4519.51,222a10,10,0,0,1,9.95-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.13,8.13,0,0,1,4521.36,240.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4501.88,233.31,4500,214.8a10,10,0,0,1,9.95-11h0a10,10,0,0,1,10,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.14,8.14,0,0,1,4501.88,233.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4461.15,140h0a7.61,7.61,0,0,0-7.27,5.37l-16.52,53.83h0a10,10,0,0,0-10-9.91h0a10,10,0,0,0-10,11l.29,2.82-2.32.46-.33-2a10,10,0,1,0-19.22,5.15l.24.65-1.65.33a10,10,0,0,0-14.12-4.55h0a10,10,0,0,0-3.12,14.5l1,1.42-12-7a36.18,36.18,0,0,0-27.58-3.58L4337,209a5.43,5.43,0,0,0-1.29,9.94L4361,233.54a21.71,21.71,0,0,1,10.12,13.18l3.66,13.68a36.91,36.91,0,0,0,2.56,6.78h0V951.26h82.12V202.52a36.29,36.29,0,0,1,.59-6.5l8.58-47A7.61,7.61,0,0,0,4461.15,140Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4437.36,199.24l16.52-53.83a7.61,7.61,0,0,1,7.27-5.37h0a7.61,7.61,0,0,1,7.48,9l-8.58,47a36.29,36.29,0,0,0-.59,6.5V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4377.34,
    y1: 267.18,
    x2: 4377.34,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4419.1,286a36.19,36.19,0,0,1-44.32-25.59l-3.66-13.68A21.71,21.71,0,0,0,4361,233.54L4335.73,219A5.43,5.43,0,0,1,4337,209l1.55-.42a36.18,36.18,0,0,1,27.58,3.58l14,8.1c3,1.73,7.9,4.49,11,6a37.35,37.35,0,0,1,19.63,23.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4419.26,218.83l-1.86-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.34h0A8.13,8.13,0,0,1,4419.26,218.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4402.4,224.17l-6.58-17.4a10,10,0,0,1,6.76-13.19h0a10,10,0,0,1,12.46,8l3,18.36a8.15,8.15,0,0,1-5.93,9.18h0A8.14,8.14,0,0,1,4402.4,224.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4378.19,219.12l-1-1.42a10,10,0,0,1,3.12-14.5h0a10,10,0,0,1,14.12,4.55l7.65,17a8.16,8.16,0,0,1-1.05,8.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3215.4,219.65a7.32,7.32,0,0,0-7.07,5.45L3196.27,271a.07.07,0,0,1-.14,0l.73-58.28a7.47,7.47,0,0,0-7.47-7.56h0a7.46,7.46,0,0,0-7.39,6.4l-8.53,59.34a.07.07,0,0,1-.14,0l-4.22-66.1a7.35,7.35,0,0,0-14.68.26L3152.58,271a.07.07,0,0,1-.14,0l-13-60.14a7.25,7.25,0,0,0-7.09-5.71h0a7.25,7.25,0,0,0-7.2,8.12l6.82,56.14a35.44,35.44,0,0,1,.27,4.36V276a36.14,36.14,0,0,0-21.56-7h-1.61a5.43,5.43,0,0,0-3.82,9.27l20.64,20.64a21.71,21.71,0,0,1,6.36,15.35v14.16h0V951.26h84.21V274.16a35.81,35.81,0,0,1,.36-5.07l5.81-41.12A7.3,7.3,0,0,0,3215.4,219.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3132.24,276V273.8a35.44,35.44,0,0,0-.27-4.36l-6.82-56.14a7.25,7.25,0,0,1,7.2-8.12h0a7.25,7.25,0,0,1,7.09,5.71l13,60.14a.07.07,0,0,0,.14,0l1.85-65.94a7.34,7.34,0,0,1,7.34-7.14h0a7.35,7.35,0,0,1,7.34,6.88l4.22,66.1a.07.07,0,0,0,.14,0l8.53-59.34a7.46,7.46,0,0,1,7.39-6.4h0a7.47,7.47,0,0,1,7.47,7.56l-.73,58.28a.07.07,0,0,0,.14,0l12.06-45.94a7.32,7.32,0,0,1,7.07-5.45h0a7.3,7.3,0,0,1,7.22,8.32l-5.81,41.12a35.81,35.81,0,0,0-.36,5.07v677.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3132.24,
    y1: 951.26,
    x2: 3132.24,
    y2: 328.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3168.42,364.61a36.19,36.19,0,0,1-36.18-36.19V314.26a21.71,21.71,0,0,0-6.36-15.35l-20.64-20.64a5.43,5.43,0,0,1,3.82-9.27h1.61a36.17,36.17,0,0,1,25.72,10.6l13.07,13.07c2.57,2.57,5.25,5,7.94,7.47a37.37,37.37,0,0,1,12.28,27.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2393.78,176.23a7.61,7.61,0,0,0-7.27,5.37L2370,235.43h0a10,10,0,0,0-19.65-2.53l-.73-.09a11.4,11.4,0,0,0-.51-1.42,36.17,36.17,0,0,0,.89-7.93V221.6a5.43,5.43,0,0,0-9.27-3.84l-12.32,12.32h0l-18.62-63a7.51,7.51,0,0,0-14.57,3.58l12,61.27a36.09,36.09,0,0,1,.68,7V951.26h84.21V238.7a36.18,36.18,0,0,1,.59-6.49l8.58-47A7.59,7.59,0,0,0,2393.78,176.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2370,235.43l16.52-53.83a7.61,7.61,0,0,1,7.27-5.37h0a7.6,7.6,0,0,1,7.48,9l-8.58,47a36.18,36.18,0,0,0-.59,6.49V951.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2328.4,230.08l-18.62-63a7.5,7.5,0,0,0-7.2-5.38h0a7.51,7.51,0,0,0-7.37,9l12,61.27a36.09,36.09,0,0,1,.68,7V951.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2344.06,324.78a36.18,36.18,0,0,1-36.18-36.18v-29a21.75,21.75,0,0,1,6.36-15.36l26.48-26.48a5.43,5.43,0,0,1,9.27,3.84v1.86a36.22,36.22,0,0,1-10.6,25.59l-6.25,6.24a3.6,3.6,0,0,0,.08,5.19,37.34,37.34,0,0,1,12.1,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2351.89,255,2350,236.51a10,10,0,0,1,9.95-11h0a10,10,0,0,1,10,11L2368.09,255a8.15,8.15,0,0,1-8.1,7.33h0A8.14,8.14,0,0,1,2351.89,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2349.08,231.35a9.94,9.94,0,0,1,.85,5.16L2348.08,255a8.13,8.13,0,0,1-8.1,7.33h0a8.13,8.13,0,0,1-7.73-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M904.78,258.84V951.26H986.9l0-645.09c0-.47,0-.93,0-1.4v-29c0-.42,0-.85,0-1.27V253.36a35,35,0,0,1,.18-3.54l6.27-63.9a7.29,7.29,0,0,0-14.41-2.09l-12.11,62.82-2.36-2.36-11.67-60.46a7.28,7.28,0,0,0-14.4,2.09L944.63,250a10,10,0,0,0-19.79,2.69l.25,2.48-1,.18a10,10,0,0,0-19.33,3.5Zm40-7.25Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 904.78,
    y1: 258.84,
    x2: 904.78,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M966.78,246.65l12.11-62.82a7.29,7.29,0,0,1,7.16-5.91h0a7.29,7.29,0,0,1,7.25,8L987,249.82a35,35,0,0,0-.18,3.54l0,697.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M944.79,251.59l-6.44-65.67a7.29,7.29,0,0,1,7.25-8h0a7.28,7.28,0,0,1,7.15,5.91l11.67,60.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M950.71,341a36.19,36.19,0,0,0,36.19-36.19v-29a21.71,21.71,0,0,0-6.36-15.35l-26.48-26.48a5.43,5.43,0,0,0-9.27,3.83v1.86a36.16,36.16,0,0,0,10.6,25.59l6.24,6.25a3.58,3.58,0,0,1-.07,5.18,37.36,37.36,0,0,0-12.1,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M942.89,271.19l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-9.95,11l1.85,18.51a8.13,8.13,0,0,0,8.1,7.33h0A8.14,8.14,0,0,0,942.89,271.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M922.89,278.44l1.85-18.51a10,10,0,0,0-10-11h0a10,10,0,0,0-9.95,11l1.85,18.51a8.15,8.15,0,0,0,8.1,7.33h0A8.15,8.15,0,0,0,922.89,278.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1233.23,261a10,10,0,0,0-20-.73h-.11l.54-5.43a10,10,0,0,0-10-11h0a10,10,0,0,0-9.74,7.72h0a36.27,36.27,0,0,0,1.35-9.76v-1.86a5.43,5.43,0,0,0-9.27-3.84l-15,15h-.15a10,10,0,0,0-7.71-3.62h0a10,10,0,0,0-10,10.95v18.19c0,.44,0,.88,0,1.32v29c0,.52,0,1,0,1.54l0,642.81h80V261Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1233.23,
    y1: 260.99,
    x2: 1233.23,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1153.28,
    y1: 258.09,
    x2: 1153.23,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1189.42,343.1a36.19,36.19,0,0,1-36.19-36.19v-29a21.71,21.71,0,0,1,6.36-15.35l26.48-26.48a5.43,5.43,0,0,1,9.27,3.84v1.86a36.16,36.16,0,0,1-10.6,25.58l-6.24,6.25a3.59,3.59,0,0,0,.07,5.19,37.34,37.34,0,0,1,12.11,27.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1154.5,270.61l-1.22-12.16a10,10,0,0,1,10-11h0a10,10,0,0,1,7.71,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1193.25,253.73a8.17,8.17,0,0,1,0,1.1l-1.85,18.51a8.13,8.13,0,0,1-8.1,7.33h0a8.13,8.13,0,0,1-3.71-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1215.13,280.58l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.14,8.14,0,0,1,1215.13,280.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1195.65,273.34l-1.85-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,1195.65,273.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1154.92,210.09h0a7.61,7.61,0,0,0-7.27,5.37l-16.52,53.83h0a10,10,0,0,0-10-9.92h0a10,10,0,0,0-10,11l.29,2.82-2.32.46-.33-2a10,10,0,1,0-19.22,5.15l.24.65-1.65.33a10,10,0,0,0-14.11-4.55h0a10,10,0,0,0-3.12,14.5l1,1.42-12-6.95a36.13,36.13,0,0,0-27.58-3.58l-1.55.42a5.43,5.43,0,0,0-1.29,9.94l25.27,14.59a21.71,21.71,0,0,1,10.12,13.18l3.66,13.68a37.19,37.19,0,0,0,2.56,6.78h0v614h82.12V272.56a36.18,36.18,0,0,1,.59-6.49l8.58-47A7.6,7.6,0,0,0,1154.92,210.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1131.13,269.29l16.52-53.83a7.61,7.61,0,0,1,7.27-5.37h0a7.6,7.6,0,0,1,7.48,9l-8.58,47a36.18,36.18,0,0,0-.59,6.49v678.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1071.11,
    y1: 337.23,
    x2: 1071.11,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1112.87,356a36.2,36.2,0,0,1-44.32-25.59l-3.66-13.68a21.71,21.71,0,0,0-10.12-13.18L1029.5,289a5.43,5.43,0,0,1,1.29-9.94l1.55-.42a36.13,36.13,0,0,1,27.58,3.58l14,8.1c3,1.72,7.9,4.49,11,6a37.35,37.35,0,0,1,19.63,23.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1113,288.88l-1.86-18.51a10,10,0,0,1,10-11h0a10,10,0,0,1,9.95,11l-1.85,18.51a8.15,8.15,0,0,1-8.1,7.33h0A8.13,8.13,0,0,1,1113,288.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1096.17,294.22l-6.58-17.4a10,10,0,0,1,6.76-13.2h0a10,10,0,0,1,12.46,8.05l3,18.36a8.15,8.15,0,0,1-5.93,9.18h0A8.15,8.15,0,0,1,1096.17,294.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1072,289.17l-1-1.42a10,10,0,0,1,3.12-14.5h0a10,10,0,0,1,14.11,4.55l7.65,16.95a8.15,8.15,0,0,1-1,8.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1319.13,176.23a7.61,7.61,0,0,0-7.27,5.37l-16.52,53.83h0a10,10,0,0,0-19.64-2.53l-.74-.09a8.9,8.9,0,0,0-.51-1.42,36.17,36.17,0,0,0,.89-7.93V221.6a5.43,5.43,0,0,0-9.27-3.84l-12.32,12.32h0l-18.62-63a7.51,7.51,0,0,0-14.57,3.58l12,61.27a36.89,36.89,0,0,1,.67,7V951.26h84.22V238.7a36.17,36.17,0,0,1,.58-6.49l8.58-47A7.59,7.59,0,0,0,1319.13,176.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1295.34,235.43l16.52-53.83a7.61,7.61,0,0,1,7.27-5.37h0a7.6,7.6,0,0,1,7.48,9l-8.58,47a36.17,36.17,0,0,0-.58,6.49V951.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1253.75,230.08l-18.62-63a7.5,7.5,0,0,0-7.2-5.38h0a7.51,7.51,0,0,0-7.37,9l12,61.27a36.89,36.89,0,0,1,.67,7V951.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1269.42,324.78a36.18,36.18,0,0,1-36.19-36.18v-29a21.75,21.75,0,0,1,6.36-15.36l26.48-26.48a5.43,5.43,0,0,1,9.27,3.84v1.86a36.18,36.18,0,0,1-10.6,25.59l-6.24,6.24a3.59,3.59,0,0,0,.07,5.19,37.34,37.34,0,0,1,12.1,27.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1277.24,255l-1.85-18.51a10,10,0,0,1,9.95-11h0a10,10,0,0,1,10,11L1293.44,255a8.14,8.14,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,1277.24,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1274.43,231.35a9.94,9.94,0,0,1,.86,5.16L1273.44,255a8.15,8.15,0,0,1-8.1,7.33h0a8.14,8.14,0,0,1-7.74-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3469.36,260.32a10,10,0,0,1,19.36-3.51l1-.17-.25-2.49a10,10,0,0,1,19.84-2.7l-6.3-64.2a7.3,7.3,0,0,1,14.44-2.1l11.68,60.59,2.37,2.37,12.14-63a7.3,7.3,0,0,1,14.44,2.1l-6.29,64c-.11,1.17-.17,2.36-.17,3.54V276c0,.42.05.84.05,1.27v29.06c0,.47,0,.93,0,1.4l0,643.51h-82.29V260.32Zm40.09-7.27h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3469.36,
    y1: 260.32,
    x2: 3469.36,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3531.48,248.11l12.14-63a7.31,7.31,0,0,1,7.17-5.92h0a7.31,7.31,0,0,1,7.27,8l-6.29,64c-.11,1.17-.17,2.36-.17,3.54l.05,696.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3509.45,253.06,3503,187.25a7.31,7.31,0,0,1,7.27-8h0a7.31,7.31,0,0,1,7.17,5.92l11.68,60.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3515.38,342.61a36.27,36.27,0,0,0,36.27-36.26V277.29a21.78,21.78,0,0,0-6.38-15.39l-26.54-26.54a5.44,5.44,0,0,0-9.28,3.85v1.87a36.27,36.27,0,0,0,10.62,25.64l6.26,6.25a3.6,3.6,0,0,1-.08,5.2,37.46,37.46,0,0,0-12.13,27.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3507.54,272.7l1.86-18.55a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.86,18.55a8.15,8.15,0,0,0,8.12,7.35h0A8.15,8.15,0,0,0,3507.54,272.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3487.5,280l1.85-18.55a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.55a8.17,8.17,0,0,0,8.12,7.35h0A8.17,8.17,0,0,0,3487.5,280Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3636,242.07a10,10,0,0,1,19.05-4.25l1.21-.27-.16-1.65a10,10,0,0,1,19.83-2.75l.33-.07a10,10,0,0,1,.72-2.31,36.35,36.35,0,0,1-.89-8V221a5.44,5.44,0,0,1,9.29-3.85l11.39,11.39h0l6-60.53a7.75,7.75,0,0,1,7.71-7h0a7.75,7.75,0,0,1,7.75,7.75v89c0,.44,0,.87,0,1.31V288.1c0,.5,0,1,0,1.51l0,661.65H3636V242.07Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3636.04,
    y1: 242.07,
    x2: 3636.04,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3696.81,228.5l6-60.53a7.75,7.75,0,0,1,7.71-7h0a7.75,7.75,0,0,1,7.75,7.75l.06,782.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3682.07,324.36a36.27,36.27,0,0,0,36.26-36.26V259a21.75,21.75,0,0,0-6.37-15.38l-26.54-26.54a5.44,5.44,0,0,0-9.29,3.85v1.86a36.3,36.3,0,0,0,10.62,25.65l6.26,6.25a3.6,3.6,0,0,1-.07,5.2,37.42,37.42,0,0,0-12.13,27.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3674.23,254.45l1.85-18.55a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.55a8.17,8.17,0,0,0,8.12,7.35h0A8.17,8.17,0,0,0,3674.23,254.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3677,230.73a10,10,0,0,0-.86,5.17l1.86,18.55a8.15,8.15,0,0,0,8.12,7.35h0a8.17,8.17,0,0,0,7.75-5.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3654.18,261.71l1.85-18.55a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.55a8.16,8.16,0,0,0,8.12,7.34h0A8.16,8.16,0,0,0,3654.18,261.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3550,204a7.62,7.62,0,0,1,7.28,5.39l16.55,53.94h0a10,10,0,0,1,20,0h0a10,10,0,0,1,10-9.94h0a10,10,0,0,1,10,9.94h0l20.24-68.44a7.53,7.53,0,0,1,14.61,3.58l-12.55,64.08h0a36.27,36.27,0,0,1,21.47-6.95h1.61a5.43,5.43,0,0,1,3.82,9.28l-20.68,20.68a21.82,21.82,0,0,0-6.34,14.18l0,11.71V951.26h-84.39V266.64a36.49,36.49,0,0,0-.59-6.51l-8.6-47.11A7.62,7.62,0,0,1,3550,204Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3573.79,263.36l-16.55-53.94A7.62,7.62,0,0,0,3550,204h0a7.62,7.62,0,0,0-7.5,9l8.6,47.11a36.49,36.49,0,0,1,.59,6.51V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3636.04,
    y1: 311.5,
    x2: 3636.04,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3613.89,263.36l20.24-68.44a7.52,7.52,0,0,1,7.22-5.39h0a7.53,7.53,0,0,1,7.39,9l-12.55,64.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3599.78,351.45A36.26,36.26,0,0,0,3636,315.19V301a21.77,21.77,0,0,1,6.37-15.39l20.68-20.68a5.43,5.43,0,0,0-3.82-9.28h-1.61a36.31,36.31,0,0,0-25.78,10.62l-13.1,13.11c-2.58,2.57-5.26,5-8,7.48a37.43,37.43,0,0,0-12.3,27.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3591.94,283l1.85-18.55a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11L3575.7,283a8.17,8.17,0,0,0,8.12,7.35h0A8.17,8.17,0,0,0,3591.94,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3612,283l1.86-18.55a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.86,18.55a8.15,8.15,0,0,0,8.12,7.35h0A8.15,8.15,0,0,0,3612,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1730.28,260.32a10,10,0,0,1,19.37-3.51l1-.17-.24-2.49a10,10,0,0,1,19.83-2.7l-6.3-64.2a7.3,7.3,0,0,1,14.44-2.1L1790,245.74l2.36,2.37,12.14-63a7.3,7.3,0,0,1,14.44,2.1l-6.28,64a34.82,34.82,0,0,0-.18,3.54V276c0,.42,0,.84,0,1.27v29.06c0,.47,0,.93,0,1.4l0,643.51h-82.29V260.32Zm40.09-7.27h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1730.28,
    y1: 260.32,
    x2: 1730.28,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1792.4,248.11l12.14-63a7.31,7.31,0,0,1,7.17-5.92h0a7.31,7.31,0,0,1,7.27,8l-6.28,64a34.82,34.82,0,0,0-.18,3.54l0,696.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1770.37,253.06l-6.46-65.81a7.31,7.31,0,0,1,7.27-8h0a7.31,7.31,0,0,1,7.17,5.92L1790,245.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1776.31,342.61a36.27,36.27,0,0,0,36.26-36.26V277.29a21.77,21.77,0,0,0-6.37-15.39l-26.54-26.54a5.44,5.44,0,0,0-9.29,3.85v1.87A36.27,36.27,0,0,0,1781,266.72l6.26,6.25a3.6,3.6,0,0,1-.07,5.2,37.42,37.42,0,0,0-12.13,27.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1768.47,272.7l1.85-18.55a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.55a8.17,8.17,0,0,0,8.12,7.35h0A8.17,8.17,0,0,0,1768.47,272.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1748.42,280l1.85-18.55a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.55a8.17,8.17,0,0,0,8.12,7.35h0A8.17,8.17,0,0,0,1748.42,280Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1897,242.07a10,10,0,0,1,19-4.25l1.21-.27-.16-1.65a10,10,0,0,1,19.83-2.75l.33-.07a10,10,0,0,1,.73-2.31,36.35,36.35,0,0,1-.89-8V221a5.44,5.44,0,0,1,9.28-3.85l11.39,11.39h0l6-60.53a7.75,7.75,0,0,1,7.71-7h0a7.75,7.75,0,0,1,7.75,7.75l0,89c0,.44,0,.87,0,1.31V288.1c0,.5,0,1,0,1.51l0,661.65H1897V242.07Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1896.96,
    y1: 242.07,
    x2: 1896.96,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1957.73,228.5l6-60.53a7.75,7.75,0,0,1,7.71-7h0a7.75,7.75,0,0,1,7.75,7.75l.06,782.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1943,324.36a36.26,36.26,0,0,0,36.26-36.26V259a21.75,21.75,0,0,0-6.37-15.38l-26.54-26.54a5.44,5.44,0,0,0-9.28,3.85v1.86a36.3,36.3,0,0,0,10.62,25.65l6.25,6.25a3.6,3.6,0,0,1-.07,5.2,37.42,37.42,0,0,0-12.13,27.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1935.15,254.45,1937,235.9a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.55a8.17,8.17,0,0,0,8.12,7.35h0A8.17,8.17,0,0,0,1935.15,254.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1938,230.73a10,10,0,0,0-.85,5.17l1.85,18.55a8.17,8.17,0,0,0,8.12,7.35h0a8.15,8.15,0,0,0,7.75-5.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1915.1,261.71l1.86-18.55a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.86,18.55a8.14,8.14,0,0,0,8.11,7.34h0A8.14,8.14,0,0,0,1915.1,261.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1516.82,113a3.06,3.06,0,0,0,3-3.34c-.33-3.49-1.64-7.26-6.72-7.26s-6.39,3.77-6.72,7.26a3.06,3.06,0,0,0,3,3.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1507.78,
    y: 113.37,
    width: 10.74,
    height: 3.9,
    transform: "translate(1628.47 -1397.83) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1490.78,118.32a3.07,3.07,0,0,0,3.06-3.34c-.34-3.49-1.64-7.26-6.72-7.26s-6.39,3.77-6.72,7.26a3.06,3.06,0,0,0,3,3.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1481.75,
    y: 118.67,
    width: 10.74,
    height: 3.9,
    transform: "translate(1607.73 -1366.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1464.75,116.78a3.06,3.06,0,0,0,3-3.34c-.33-3.48-1.64-7.25-6.72-7.25s-6.38,3.77-6.72,7.25a3.06,3.06,0,0,0,3.05,3.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1455.71,
    y: 117.13,
    width: 10.74,
    height: 3.9,
    transform: "translate(1580.17 -1342) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1516.82,197.67a3.06,3.06,0,0,1,3,3.34c-.33,3.49-1.64,7.26-6.72,7.26s-6.39-3.77-6.72-7.26a3.06,3.06,0,0,1,3-3.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1507.78,
    y: 193.42,
    width: 10.74,
    height: 3.9,
    transform: "translate(1317.78 1708.52) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1490.78,192.37a3.07,3.07,0,0,1,3.06,3.34c-.34,3.49-1.64,7.26-6.72,7.26s-6.39-3.77-6.72-7.26a3.06,3.06,0,0,1,3-3.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1481.75,
    y: 188.12,
    width: 10.74,
    height: 3.9,
    transform: "translate(1297.04 1677.19) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1464.75,193.91a3.06,3.06,0,0,1,3,3.34c-.33,3.48-1.64,7.25-6.72,7.25s-6.38-3.77-6.72-7.25a3.06,3.06,0,0,1,3.05-3.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1455.71,
    y: 189.65,
    width: 10.74,
    height: 3.9,
    transform: "translate(1269.48 1652.69) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2013,31.09a33,33,0,0,1-31.71,5.54A110.34,110.34,0,0,0,1943.34,30c-61.24,0-78.06,49.65-78.06,110.89s16.82,110.89,78.06,110.89a110.34,110.34,0,0,0,37.93-6.68,33,33,0,0,1,31.71,5.54,139.14,139.14,0,0,0,86.61,30.09c77.24,0,107-62.61,107-139.84S2176.83,1,2099.59,1A139.14,139.14,0,0,0,2013,31.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2003.48,259.75a34.89,34.89,0,0,1,9.5,5.34,139.08,139.08,0,0,0,86.61,30.09c77.24,0,107-62.6,107-139.83s-29.78-139.84-107-139.84A139.08,139.08,0,0,0,2013,45.6c-9,7.09-21,9.46-31.71,5.54a110.34,110.34,0,0,0-37.93-6.68c-61.24,0-78.06,49.64-78.06,110.89s16.82,110.88,78.06,110.88a110.52,110.52,0,0,0,31.43-4.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2195.73,155.35h0c0-38.74-7.84-70.83-22.68-92.79a79,79,0,0,0-29.16-26.4c-12.5-6.48-27.41-9.77-44.3-9.77a128.24,128.24,0,0,0-79.86,27.75A45,45,0,0,1,1992,63.9a42.24,42.24,0,0,1-14.45-2.54,99.33,99.33,0,0,0-34.2-6c-24.62,0-41.84,8.87-52.63,27.13-9.66,16.34-14.55,40.86-14.55,72.87h0c0,32,4.89,56.53,14.55,72.87,10.79,18.26,28,27.13,52.63,27.13a99.33,99.33,0,0,0,34.2-6,42.24,42.24,0,0,1,14.45-2.54,45,45,0,0,1,27.74,9.77,128.24,128.24,0,0,0,79.86,27.75c16.89,0,31.8-3.29,44.3-9.77a79,79,0,0,0,29.16-26.4c14.84-22,22.68-54,22.68-92.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2080.61,293.9l125.71-125.72q.29-6.35.29-12.84a265.65,265.65,0,0,0-1.46-28.43L2047.09,285A138.64,138.64,0,0,0,2080.61,293.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2099.59,15.51A139.08,139.08,0,0,0,2013,45.6c-9,7.09-21,9.46-31.71,5.54-1.66-.61-3.33-1.16-5-1.69L1865.32,160.37c.92,58.91,18.47,105.86,78,105.86a110.52,110.52,0,0,0,31.43-4.53l28.71-1.95a34.89,34.89,0,0,1,9.5,5.34,141.23,141.23,0,0,0,11.76,8.36L2200.06,98.13C2187.58,49.43,2156.44,15.51,2099.59,15.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1948.2,44.56c-1.61-.07-3.23-.1-4.86-.1-51.06,0-71.24,34.52-76.54,81.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2013,265.09c-9-7.09-21-9.46-31.71-5.54-.67.25-1.34.48-2,.72v691h84.39V290.51h0A139.41,139.41,0,0,1,2013,265.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2003.48,259.75a34.89,34.89,0,0,1,9.5,5.34,139.08,139.08,0,0,0,86.61,30.09c77.24,0,107-62.6,107-139.83s-29.78-139.84-107-139.84A139.08,139.08,0,0,0,2013,45.6c-9,7.09-21,9.46-31.71,5.54a110.34,110.34,0,0,0-37.93-6.68c-61.24,0-78.06,49.64-78.06,110.89s16.82,110.88,78.06,110.88a110.52,110.52,0,0,0,31.43-4.53"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2063.64,
    y1: 290.51,
    x2: 2063.64,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1979.25,
    y1: 951.26,
    x2: 1979.25,
    y2: 289
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2015.69,325.15a36.27,36.27,0,0,1-36.4-36.13l0-14.19a21.72,21.72,0,0,0-6.43-15.36l-20.75-20.61a5.44,5.44,0,0,1,3.79-9.3h1.61a36.26,36.26,0,0,1,25.81,10.53l13.15,13c2.59,2.57,5.28,5,8,7.46a37.43,37.43,0,0,1,12.4,27.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2015.69,325.15a36.27,36.27,0,0,1-36.4-36.13l0-14.19a21.72,21.72,0,0,0-6.43-15.36l-20.75-20.61a5.44,5.44,0,0,1,3.79-9.3h1.61a36.26,36.26,0,0,1,25.81,10.53l13.15,13c2.59,2.57,5.28,5,8,7.46a37.43,37.43,0,0,1,12.4,27.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1730.28,134.93a10,10,0,0,0-20-.73h-.12l.55-5.44a10,10,0,0,0-10-11h0a10,10,0,0,0-9.76,7.74h0a36.1,36.1,0,0,0,1.36-9.79v-1.87A5.44,5.44,0,0,0,1683,110l-15,15h-.16a10,10,0,0,0-7.72-3.62h0a10,10,0,0,0-10,11v18.23c0,.44-.05.88-.05,1.32V181c0,.52,0,1,0,1.54l0,768.77h80.17V134.93Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1730.28,
    y1: 134.93,
    x2: 1730.28,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1650.16,
    y1: 132.03,
    x2: 1650.11,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1865.28,131.77,1553.41,135c-13.54,0-25.71-6.6-30.74-16.67h0a2.43,2.43,0,0,0-2.64-1.09l-21.81,4.22a116.66,116.66,0,0,1-46.2-.43h0a2.28,2.28,0,0,0-2.83,1.53l-.59,3.8a28,28,0,0,1-8.15,15.44h0c-6.61,6.63-6.61,16,0,22.65h0a28,28,0,0,1,8.15,15.45l.59,3.8a2.28,2.28,0,0,0,2.83,1.53h0a116.66,116.66,0,0,1,46.2-.43l21.81,4.22a2.45,2.45,0,0,0,2.64-1.09h0c5-10.07,17.2-16.67,30.74-16.67l311.88,3.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2138.4,131.08l-585,6.14c-13.54,0-25.71-6.6-30.74-16.67h0a2.43,2.43,0,0,0-2.64-1.09l-21.81,4.22a116.84,116.84,0,0,1-46.2-.43h0a2.28,2.28,0,0,0-2.83,1.53l-.59,3.79a28,28,0,0,1-8.15,15.45h0c-6.61,6.62-6.61,16,0,22.65h0a28,28,0,0,1,8.15,15.45l.59,3.79a2.28,2.28,0,0,0,2.83,1.53h0a116.84,116.84,0,0,1,46.2-.43l21.81,4.22a2.43,2.43,0,0,0,2.64-1.09h0c5-10.07,17.2-16.67,30.74-16.67l585,6.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1515.92,133a44.39,44.39,0,0,0,18.68,13.28,9.77,9.77,0,0,1,6.33,9.09h0a9.77,9.77,0,0,1-6.33,9.1,44.39,44.39,0,0,0-18.68,13.28l-15.33-3a129.16,129.16,0,0,0-41.32-1.22,41.76,41.76,0,0,0-10-15.69,3.55,3.55,0,0,1,0-5,41.76,41.76,0,0,0,10-15.69,128.71,128.71,0,0,0,16.9,1.11,129.38,129.38,0,0,0,24.42-2.33l15.33-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1553.41,137.22a40.28,40.28,0,0,1-13.87-2.45l-50.83,50.83c3.19.34,6.37.81,9.51,1.41l16.65,3.22L1568,137.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1522.67,120.55a2.43,2.43,0,0,0-2.64-1.09l-21.81,4.21a116.77,116.77,0,0,1-40.42.65l-11.49,11.49a30,30,0,0,1-5.86,8.21c-6.61,6.62-6.61,16,0,22.65h0a28,28,0,0,1,8.15,15.45l.59,3.79a2.28,2.28,0,0,0,2.83,1.53h0a114.57,114.57,0,0,1,14.66-2.14l59.51-59.51A24.92,24.92,0,0,1,1522.67,120.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2035.95,
    cy: 155.34,
    r: 49.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2138.4,131.08l-585,6.14c-13.54,0-25.71-6.6-30.74-16.67h0a2.43,2.43,0,0,0-2.64-1.09l-21.81,4.22a116.84,116.84,0,0,1-46.2-.43h0a2.28,2.28,0,0,0-2.83,1.53l-.59,3.79a28,28,0,0,1-8.15,15.45h0c-6.61,6.62-6.61,16,0,22.65h0a28,28,0,0,1,8.15,15.45l.59,3.79a2.28,2.28,0,0,0,2.83,1.53h0a116.84,116.84,0,0,1,46.2-.43l21.81,4.22a2.43,2.43,0,0,0,2.64-1.09h0c5-10.07,17.2-16.67,30.74-16.67l585,6.14"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1513.15,
    cy: 178.85,
    r: 4.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1487.12,
    cy: 175.21,
    r: 4.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1461.08,
    cy: 171.58,
    r: 4.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1513.15,
    cy: 131.84,
    r: 4.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1487.12,
    cy: 135.48,
    r: 4.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1461.08,
    cy: 139.11,
    r: 4.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1513.15 178.85 1576.26 169.85 2145.65 173.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1487.12 175.21 1576.26 164.41 2145.65 166.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1461.08 171.57 1576.26 158.25 2145.65 159.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1513.15 131.84 1576.26 140.84 2145.65 137.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1487.12 135.48 1576.26 146.28 2145.65 144.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1461.08 139.12 1576.26 152.44 2145.65 150.99"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2145.65,
    cy: 173.48,
    r: 1.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2145.65,
    cy: 166.58,
    r: 1.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2145.65,
    cy: 159.7,
    r: 1.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2145.65,
    cy: 151.16,
    r: 1.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2145.65,
    cy: 144.1,
    r: 1.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2145.65,
    cy: 137.22,
    r: 1.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2154.81,114.32V127.2a18.06,18.06,0,0,0,1.59,7.42l2.64,5.89a36.27,36.27,0,0,1,0,29.67l-2.64,5.89a18.06,18.06,0,0,0-1.59,7.42v12.88H2138.4V114.32Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1926.54,
    y1: 177.39,
    x2: 1926.54,
    y2: 133.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1882.78,
    y1: 176.93,
    x2: 1882.78,
    y2: 133.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1839.01,
    y1: 176.47,
    x2: 1839.01,
    y2: 134.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1795.25,
    y1: 176.01,
    x2: 1795.25,
    y2: 134.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1751.49,
    y1: 175.55,
    x2: 1751.49,
    y2: 135.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1707.73,
    y1: 175.09,
    x2: 1707.73,
    y2: 135.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1576.44,
    y1: 173.71,
    x2: 1576.44,
    y2: 136.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1663.96,
    y1: 174.63,
    x2: 1663.96,
    y2: 136.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1620.2,
    y1: 174.17,
    x2: 1620.2,
    y2: 136.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1692.31,113.81A5.44,5.44,0,0,0,1683,110l-15,15-.13,0a10,10,0,0,0-7.72-3.62h0a10,10,0,0,0-10,11l1.22,12.19h0a21.8,21.8,0,0,0-1.27,7.32V181a36.26,36.26,0,0,0,36.26,36.26l1.26-36.81a37.37,37.37,0,0,0-11.08-26.61,8.14,8.14,0,0,0,3.65.86h0a8.14,8.14,0,0,0,8.11-7.34l1.86-18.55c0-.32,0-.63,0-.94a36.29,36.29,0,0,0,2.1-12.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1712.14,154.56,1710.28,136a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11l-1.86,18.55a8.15,8.15,0,0,1-8.12,7.35h0A8.15,8.15,0,0,1,1712.14,154.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1692.62,147.31l-1.86-18.55a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11l-1.86,18.55a8.14,8.14,0,0,1-8.11,7.34h0A8.14,8.14,0,0,1,1692.62,147.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1686.37,217.21A36.26,36.26,0,0,1,1650.11,181V151.89a21.75,21.75,0,0,1,6.37-15.38L1683,110a5.44,5.44,0,0,1,9.29,3.84v1.87a36.25,36.25,0,0,1-10.62,25.64l-6.26,6.26a3.6,3.6,0,0,0,.07,5.2,37.39,37.39,0,0,1,12.13,27.62"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2109.22,193.9,2090,192.59a65.65,65.65,0,0,1-116-15.43h0a86.47,86.47,0,0,0,30.31,52.8h0a79.49,79.49,0,0,0,50.61,18.2h42a32.55,32.55,0,0,0,32.55-32.55h0A21.77,21.77,0,0,0,2109.22,193.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1651.38,144.57l-1.22-12.19a10,10,0,0,1,10-11h0a10,10,0,0,1,7.72,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1690.22,127.66a10.24,10.24,0,0,1,0,1.1l-1.86,18.55a8.14,8.14,0,0,1-8.11,7.34h0a8.09,8.09,0,0,1-3.73-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1712.14,154.56,1710.28,136a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11l-1.86,18.55a8.15,8.15,0,0,1-8.12,7.35h0A8.15,8.15,0,0,1,1712.14,154.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1692.62,147.31l-1.86-18.55a10,10,0,0,1,10-11h0a10,10,0,0,1,10,11l-1.86,18.55a8.14,8.14,0,0,1-8.11,7.34h0A8.14,8.14,0,0,1,1692.62,147.31Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2035.95,
    cy: 155.34,
    r: 65.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2088.77,229.19c.9-.91,1.79-1.82,2.63-2.75.2-.23,1-.82.95-1.15a3.35,3.35,0,0,0-.92.39,16.15,16.15,0,0,0-4.22,2.43c-3.68,3.16-7.69,6.54-12.12,8.61a10.17,10.17,0,0,1-1.09.41c-.42.16-.38.34-.82,0-.84-.64-.31-1,.37-1.52,1.26-.92,2.44-2,3.68-3a51.65,51.65,0,0,1,5.93-4c1.94-1.11,4.34-1.88,5.89-3.55.26-.27,1.35-1.27,1-1.74-.11-.17-1.16-.15-1.34-.16-4-.22-8.19,1.81-11.59,3.69a9.09,9.09,0,0,1-.87.52c-.59.24-1.2.17-1.09,1a1.89,1.89,0,0,1-.68,1.41,34.55,34.55,0,0,1-6,4.75q-5,3.33-10.22,6.31c.2.45.78.56,1.28.58,3.26.2,6.6-.36,9.77.44.42.11.93.41.79.82s-.76.34-1.19.2c-3.57-1.16-7.66.4-11.16-1-.53-.21-1.12-.76-.83-1.24a1,1,0,0,1,.37-.31c4.54-2.79,9.16-5.44,13.56-8.44a9.56,9.56,0,0,0,3.53-3.53c-4.7-.16-9.26,1.42-13.7,3-.5.17-1.07.43-1.17.94a2,2,0,0,0,.13.91c.34,1.39-.38,2.79-1.13,4a51,51,0,0,1-20.23,18.65c-.68.34-1.67.59-2.07-.06a1.57,1.57,0,0,1,.11-1.36c3.23-7.66,9.44-13.66,16-18.74a42.16,42.16,0,0,1,5.34-3.63,7,7,0,0,0-3.06,0c-6,.92-11.5,4-16.81,7-.36.21-1,.3-1-.12,0-.24.21-.42.41-.55a61.6,61.6,0,0,1,11.18-5.4,21.31,21.31,0,0,1,9.68-1.65,4.53,4.53,0,0,0,.9,0,3.62,3.62,0,0,0,1-.34,47.44,47.44,0,0,1,6.86-2.35c2.21-.57,4.18-.66,6.34-1.06a15.68,15.68,0,0,0,4.16-1.87,35.55,35.55,0,0,1,8.72-2.93c1.2-.26,3.17-.8,4.31-.14.51.3.92.76.7,1.37-.17.45-.84.85-.89,1.26.21,0,.56-.28.81-.36s.71-.18,1.05-.31a24.27,24.27,0,0,0,4.16-1.79c1.36-.83,2.56-1.93,3.9-2.81a60.3,60.3,0,0,1,9-4.8c3.09-1.32,6.71-3,10.13-3-1.52,0-3.77,1.39-5.17,2-1.76.74-3.51,1.54-5.24,2.35s-3.79,1.61-5.64,2.52-3.08,2-4.68,3a9.69,9.69,0,0,1-1.3.74c-.4.16-.88.52-.05.45a14.66,14.66,0,0,1,3.45-.38,1.26,1.26,0,0,1,.57.17c.78.55-.2,1.59-.65,2-.24.19-.48.17-.55.55a13,13,0,0,0,2.27-.58,20.81,20.81,0,0,1,2.83-.44c1.22-.09,4-.31,3.72,1.75a4.64,4.64,0,0,0-.38.39,43.41,43.41,0,0,1-7.19,5.84c-1.34.94-2.71,1.85-4.08,2.75a24.12,24.12,0,0,1-4.15,2.62A56.43,56.43,0,0,0,2103.8,232q5.92-3.87,11.63-8.05,2.81-2.05,5.56-4.18a23.6,23.6,0,0,0,2.38-2,4.24,4.24,0,0,0,1.4-2.06.25.25,0,0,0,0-.19.26.26,0,0,0-.23-.08,6.22,6.22,0,0,0-1.82.22.87.87,0,0,1-.45,0c-.1,0-.16-.06-.16-.16.8-.68,4.6-1.73,4.1.35a2.77,2.77,0,0,1-.72,1.16c-3.67,4.08-8.76,7.19-13.23,10.31-3.93,2.74-7.8,5.56-12,7.93-2.12,1.2-4.47,2.79-6.83,3.46-2.4,1-5,2.27-7.7,2.07-1.39-.11-3.8-.57-3.78-2.44,0-1.51,1.42-2.78,2.18-3.9A39.1,39.1,0,0,1,2088.77,229.19Zm4.75,8.05a76.52,76.52,0,0,0,7.6-5.48c1.25-1,2.79-1.81,3.94-2.87a14.47,14.47,0,0,0,2.73-2.63.81.81,0,0,0,.18-.64c-.09-.29-.43-.4-.72-.45-2.79-.49-6.17.69-8.7,1.81-2,.9-3.83,2.38-5.92,3.3l-1.58.69c-1,.45-2.07-.47-.84-1,2-.92,3.9-1.84,5.86-2.73a18.63,18.63,0,0,0,3-1.55,4.64,4.64,0,0,0,1.88-2.21c-.1.24-2.2.19-2.49.23a10.43,10.43,0,0,0-7.28,4.11l-.24-.22c.4.37-2.9,3.55-3.22,3.87-1.63,1.64-3.65,3.32-4.56,5.5a2.1,2.1,0,0,0,.34,2.41,2.6,2.6,0,0,0,1.65.47A15.89,15.89,0,0,0,2093.52,237.24ZM2041,247.93a21.33,21.33,0,0,0-3.1,5,4.22,4.22,0,0,0-.46,2.22,36.61,36.61,0,0,0,5.8-3.31,41.27,41.27,0,0,0,5.15-4c1.18-1.08,2.28-2.11,3.37-3.28,1.32-1.42,2.52-2.87,3.71-4.38a17.26,17.26,0,0,0,3.19-5.62,3.13,3.13,0,0,0,.17-1.25c-.21-1.27-4,1.48-4.52,1.83a41.41,41.41,0,0,0-6.23,4.89,48,48,0,0,0-5.58,6Zm34.46-12.62c.2.34,4.59-2.6,5.18-3,1.42-1,3.94-2.39,4.77-3.87a1.88,1.88,0,0,0-1.12.5C2084,229.18,2075.13,234.78,2075.45,235.31Zm17.22-10.23c-.16,0-.15.32-.17.45C2092.66,225.36,2092.72,225.31,2092.67,225.08Zm-49.11,19.64c0,.18.13.18.26,0a.31.31,0,0,0,0-.1Zm55.77-23.64c.05-.12,0-.17-.11-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2128.64,210.34l0-.07a10.81,10.81,0,0,1,7.66.78,2.4,2.4,0,0,1,1.41,1.43,2.67,2.67,0,0,1-.92,2.18,54.44,54.44,0,0,1-16.34,12.26c-1,.51-2,1-3,1.46-.4.19-2.56,1.54-2.8,1.42.91.48,2.72.27,3.81.32,2.46.11,5.45.7,7.85-.06,1.38-.44,2.65-1.15,4-1.66,1.2-.47,2.51-.66,3.67-1.25a48,48,0,0,0,8.92-5.47c3-2.51,6-5.16,9-7.73.26-.22.59-.46.91-.33a.65.65,0,0,1,.28.84,1.89,1.89,0,0,1-.64.74l-7.45,6a49.28,49.28,0,0,0-7.78,7.28c5.22-1.24,9.75-4.6,15-5.75-.6.14-1,.81-1.6,1.07-1.23.58-2.43.91-3.62,1.58a42.36,42.36,0,0,1-4.12,2L2138,229.5a2.79,2.79,0,0,1-1.48.35,1,1,0,0,1-.92-1,1.44,1.44,0,0,1,.43-.69l2-2.17a9.52,9.52,0,0,1-2.16,1.17c-.84.48-1.67,1-2.49,1.51-1.39.88-3,.74-4.46,1.42-1.11.51-3.07,2-4.34,1.72a8.17,8.17,0,0,0-2.1-.43q-3.1,0-6.21,0c-1.36,0-4.49.47-5.63-.37-.35-.25-.42-.88,0-1.06a.87.87,0,0,1,.32-.06,15.41,15.41,0,0,0,3.89-1A52,52,0,0,0,2136,214a2,2,0,0,0,.61-1.28,1.67,1.67,0,0,0-1.16-1.24c-1.86-.77-4-.47-6-.69C2129.13,210.72,2128.76,210.62,2128.64,210.34Zm-.38,11c-.18.1,0,.27.14.25Zm-3.34,2.64q-.14-.06-.15.06T2124.92,224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2128.07,210.52a.33.33,0,0,1-.29.29,54.87,54.87,0,0,1-6.53.77,4.36,4.36,0,0,0-1.33.37c.6-.83,1.76-.81,2.68-.9,1.47-.14,2.86-.67,4.33-.82A1.42,1.42,0,0,1,2128.07,210.52Zm-2,.4c-.1-.21-.28-.06-.33.13Zm.74-.57c-.22,0-.25.07-.18.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2152.71,54.48a.61.61,0,0,0-.18.05,2.1,2.1,0,0,0-.5.4,2.37,2.37,0,0,1-.82.38c-2.52.81-5.06,1.55-7.62,2.24a.59.59,0,0,1-.47,0,.4.4,0,0,1,0-.58,1.18,1.18,0,0,1,.55-.33l2.17-.81a15.39,15.39,0,0,1,4.53-1.18,2.4,2.4,0,0,0,1-.18,5.63,5.63,0,0,0,.46-.36,5.55,5.55,0,0,1,2.18-.71,4.5,4.5,0,0,0,1.93-1,3.49,3.49,0,0,0-.54-.12l-1-.07c-.67,0-1.35,0-2,0a30.25,30.25,0,0,0-4,.44,76.93,76.93,0,0,0-7.9,1.9c-.22.06-.49.16-.54.39a1.45,1.45,0,0,0,0,.36.94.94,0,0,1-.59.83,3.05,3.05,0,0,1-1.05.19,55.87,55.87,0,0,0-6,.78c-1,.19-2.08.39-3.11.65a24,24,0,0,0-3.64,1.4l-.08,0a3.67,3.67,0,0,0-.83.44,1.16,1.16,0,0,0-.48.78.39.39,0,0,0,0,.26c.18.29,1,0,1.22,0,.59-.08,1.14-.21,1.72-.34,3.68-.87,7.39-1.66,11.1-2.38a.45.45,0,0,1-.07.39.45.45,0,0,0,.54-.15,4.42,4.42,0,0,1,.39-.47c.15-.13.43-.17.54,0a.47.47,0,0,1,.06.2l.13.67a12,12,0,0,1-2.58.72q-6,1.23-11.86,2.88a8.84,8.84,0,0,1-2.63.48,1.55,1.55,0,0,1-1.14-.38,1.28,1.28,0,0,1-.13-1.37,5.13,5.13,0,0,1,1.86-1.87,4.05,4.05,0,0,0-.77,0c-.42,0-.85.12-1.27.17-3,.39-6,.91-9,1.32a5.94,5.94,0,0,1-1.63.06,1.92,1.92,0,0,1-1.36-.84,1.14,1.14,0,0,1,.57-1.65,29.75,29.75,0,0,1,6.25-1.54,6.64,6.64,0,0,1,2.94-.1,1.46,1.46,0,0,1,1.07,1.16c.13.41-.07.46.38.5,1.48.15,3.47-.51,4.93-.8,5.24-1,10.32-2.67,15.42-4.2a47.52,47.52,0,0,1,11.1-2.4c1-.05,6.9-.19,5.9,2a2,2,0,0,1-.79.81,6.26,6.26,0,0,1-3.86,1A2.14,2.14,0,0,0,2152.71,54.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2059.4,41.46c7.19-1.5,14.61-.83,21.92.66a27.4,27.4,0,0,1,3.08.82,8.2,8.2,0,0,1,3,1.32c.39.34.87,1,.57,1.51-.16.3-.68.38-.83.07a1.14,1.14,0,0,1-.07-.32c-.28-1.59-5-2.37-6.23-2.66a74.61,74.61,0,0,0-8.42-1.24c-1.33-.14-2.61-.29-4-.32a37.81,37.81,0,0,0-19.08,4.44,47.37,47.37,0,0,0-8.34,5.92c-1.24,1.08-2.43,2.21-3.59,3.38-.43.45-2.69,3.51-3.17,3.48,2.3.14,4.45-1,6.44-2.18,5.52-3.2,10.94-6.56,16.15-10.24a.8.8,0,0,1,.25,1.06,2.2,2.2,0,0,1-.88.8c-4.93,3.13-9.85,6.25-14.93,9.13a20.53,20.53,0,0,1-6.88,2.81,1.33,1.33,0,0,1-.88-.07c-.75-.41-.3-1.55.24-2.21a49.53,49.53,0,0,1,19.62-14.34A35.83,35.83,0,0,1,2059.4,41.46Zm-2.49.65.15.33C2057.33,42.19,2057,42.19,2056.91,42.11Zm-4.55,2c.21-.15.17-.12.22-.34C2052.41,43.9,2052.32,43.89,2052.36,44.11Zm-12,7.62c0,.08,0,.1.11.06S2040.41,51.66,2040.35,51.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2098.31,53.25a6.22,6.22,0,0,1-2.83,2.39q-5.33,2.85-10.9,5.24a46.21,46.21,0,0,1-8.54,2.9,4.84,4.84,0,0,1-2.82,0,1.9,1.9,0,0,1-1.21-2.28,45,45,0,0,1-16.68,7.05,1.11,1.11,0,0,1-.65,0c-.6-.27-.28-1.18.17-1.65a8.94,8.94,0,0,1,4.25-2.52,12.21,12.21,0,0,1-3,2.72c5.51-.89,10.6-3.48,15.26-6.53,3.29-2.16,6.41-4.55,9.6-6.86.81-.58,1.62-1.16,2.44-1.72.27-.19,1.75-1.47,1.6-.36s-2.14,2-3,2.56a44.35,44.35,0,0,0-8.62,7.38c-.3.32-.61.77-.43,1.17a1,1,0,0,0,.78.47,6.47,6.47,0,0,0,2.95-.31C2084.35,60.78,2091,56.14,2098.31,53.25ZM2084,51.67c.59.22.76-.08.78-.65C2084.5,51.49,2084.49,51.58,2084,51.67Zm-11.61,9.5c-.15-.13-.26.14-.16.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2108.53,55.35c-2.11.26-4.22.49-6.34.71l-3.37.34a.72.72,0,0,1-.41,0c-.32-.14-.3-.65,0-.89a1.67,1.67,0,0,1,1-.31c4.82-.41,9.62-1,14.39-1.83,4.55-.79,9.54-1.27,13.57-3.71a3,3,0,0,0,1.05-.93c1.24-2-2.85-3.32-4.06-3.85a33.69,33.69,0,0,0-20-2.3,1.5,1.5,0,0,1-.63,0,.47.47,0,0,1-.38-.45c6.44-1.82,13.19-1.08,19.49,1,.7.23,1.44.56,2.12.83,1.65.65,3.43,1.53,4.29,3.17a2.72,2.72,0,0,1,.34,1.52c-.2,1.83-2.2,2.62-3.71,3.15A82.67,82.67,0,0,1,2108.53,55.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2140,58.49c.07-.36.14-1,.43-1.25s1,0,1.24.31l.45-.35-.38-.21c.28-.34.6-.2,1-.19l-.31.11c.75.33,0,.9-.45,1.07A6,6,0,0,1,2140,58.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2086.8,49.61a1.61,1.61,0,0,1,1-.73,1.17,1.17,0,0,1,.89.28.47.47,0,0,0-.43.48c0-.42-1,.59-1,.63-.37.3-.8.51-1.19.79a1.16,1.16,0,0,1,.71-1.44,1.72,1.72,0,0,0,.07.21A.28.28,0,0,1,2086.8,49.61Zm1-.2c.23,0,.08-.33-.05-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2102.4,43c-.26,0-.66-.08-.91-.06s-.28-.08-.49.33c-.14-.67.34-.62.81-.78.18-.06.47-.45.72-.19S2102.49,42.84,2102.4,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2098.32,44c-.47.85-.72.77-1.6.5A1.59,1.59,0,0,1,2098.32,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2093.72,46.16a3.12,3.12,0,0,1-.62.4c0-.08-.16-.14-.21-.21s-.75.68-.82.76,0-.49,0-.57c.16-.27.51-.32.76-.41C2092.92,46.11,2093.74,45.89,2093.72,46.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2090.77,47.41c.5.75-.62,1-1.07,1.22a1.2,1.2,0,0,1,.05-.51.2.2,0,0,1-.07-.21C2089.63,48.15,2090.7,47.47,2090.77,47.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2098.32,44c-.08-.22.37-.51.6-.59.64-.2.78.38,0,.33,0,.07.14.37-.07.36s-.24-.1-.4-.31Q2098.2,43.92,2098.32,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2100.68,42.73c.06.53,0,.62-.41.71C2100.27,43.13,2100.28,42.85,2100.68,42.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2096.28,44.59l-.38.64C2095.64,44.83,2095.74,44.66,2096.28,44.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2103.11,42.18c.11.46.09.41-.35.57A.55.55,0,0,1,2103.11,42.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2089,48.9a2.73,2.73,0,0,1-.54-.24C2088.54,48,2088.94,48.76,2089,48.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2091.85,47.09l-.44,0C2091.52,46.83,2091.84,46.78,2091.85,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2099.92,43.63l-.18-.53C2100.09,43.24,2100.12,43.33,2099.92,43.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2091.84,47.1c0,.23.1.67-.33.47C2091.51,47.58,2091.82,47.1,2091.84,47.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2093.73,46.17c-.06-.34,0-.41.3-.47C2093.93,45.85,2093.81,46,2093.73,46.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2089.21,48.86l.14-.23A.13.13,0,0,1,2089.21,48.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2095.53,45.16c.18.12.08.2-.1.26C2095.58,45.17,2095.61,45.08,2095.53,45.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2090.78,47.42l.23-.23C2091,47.28,2090.86,47.51,2090.78,47.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2095.54,45.15c-.16-.08-.15-.17,0-.28C2095.46,45.13,2095.46,45.22,2095.54,45.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2118.35,280.6a20.15,20.15,0,0,1,.11-2.06c.15-.84.25-1.68.48-2.49.39-1.38,1.14-2.67,1.47-4.06.61-2.55,1.69-5.08,2.52-7.58.35-1.05.55-2.33-.35-3.17a1.56,1.56,0,0,0-1.53-.39,5.48,5.48,0,0,0-1.65,1.8c-1.54,2.11-3,4.27-4.75,6.22.08-1.84,1.34-3.62,1.86-5.38.28-.94,1.1-2,1.14-3,0-.79-.83-2.06-1.75-1.6-1.76.88-2.91,4-3.75,5.7-.57,1.14-1.12,2.26-1.77,3.37-.45.78-.72,1.79-1.51,2.27a26.27,26.27,0,0,0,.5-4.5,12.48,12.48,0,0,0-.09-2.52c-.09-.45-.29-.78-.11-1.23a4,4,0,0,1,.73-.9,8.49,8.49,0,0,0,1.25-1.89,68.16,68.16,0,0,0,3.08-6.38c.87-2.4,1.53-4.88,2.19-7.34.34-1.26-.59-1.71-1.08-.46a21.33,21.33,0,0,0-.63,2.74,23.36,23.36,0,0,1-1.36,4.09c-1.36,2.88-2.47,6-4.53,8.45-.32.38-1,1-1.37.23-.08-.14,0-.43,0-.62a2.83,2.83,0,0,0-.58-1.41c-.25-.28-1.44-.9-1.51-.12,0,.39.54.47.73.68,1.2,1.34-.45,3.25-1,4.5a35.83,35.83,0,0,1-2.86,5.71,17.47,17.47,0,0,1-3.14,3.51c-.19.16-.4.43-.25.63a.45.45,0,0,0,.45.1c1.55-.26,2.48-1.82,3.28-3a42.15,42.15,0,0,0,2.2-3.8,7.61,7.61,0,0,1,3.29-3.16,7.21,7.21,0,0,1,.18,2.89,25.83,25.83,0,0,1-.55,4.12,11.79,11.79,0,0,1-1.92,4.9,1.86,1.86,0,0,0-.61,1.22c0,.21.12.41.16.62.11.51-.78,2.1.49,2.07.68,0,1-1.92,1.26-2.53.94-2.44,2.6-4.64,3.81-6.95.81-1.56,1.56-3.12,2.46-4.63.68-1.12,1.19-2.47,2.28-3.21a104.84,104.84,0,0,1-3.84,9.95c-.3.62-.38.91.17,1.47s.73.41,1.11,0c.77-.79,1.4-1.8,2.11-2.65a16,16,0,0,0,1.28-1.78c.53-.84,1.25-1.54,1.83-2.35.84-1.18,1.74-3.65,3.25-4.09a.23.23,0,0,1,.2,0c.12.06.1.23.07.35-.65,2.56-1.51,5.12-2.4,7.6a46.19,46.19,0,0,0-2.38,8.05,3.45,3.45,0,0,0,0,1.43,1.35,1.35,0,0,0,.95,1,.44.44,0,0,0,.23,0,.44.44,0,0,0,.16-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2111.38,87.83A44,44,0,0,0,2117.12,77c.21-.62.31-1.47-.27-1.77a1.42,1.42,0,0,0-1.32.28c-8.61,5.24-14.87,13.59-19.93,22.31a2.87,2.87,0,0,0-.53,2.47c4.91-8.87,10.85-17.52,19.28-23.17a3.54,3.54,0,0,1,2.07-.8,38,38,0,0,1-4.68,9.45c-3,4.33-6.21,8.53-9.32,12.78-.06.08-.13.16-.22.15s-.15-.24-.11-.39l2.44-7.55a4.3,4.3,0,0,0,.29-2.39,11.12,11.12,0,0,0-1.44,3.15c-.69,2.07-1.29,4.17-1.9,6.27l-2.3,8c-.12.45-.19,1,.22,1.25,1.11-2,1.1-4.42,2.12-6.44.06-.13.14-.26.27-.29s.43.23.67.24.38-.21.49-.4C2105.45,95.84,2108.58,91.92,2111.38,87.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2156.78,88.72c-.25,0-.35.27-.53.42a2,2,0,0,0,.84-.28A.23.23,0,0,0,2156.78,88.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2155.71,89.41c.14-.08.28-.16.41-.25a2.79,2.79,0,0,0-1.18.09,64.21,64.21,0,0,0-7,1.84,16.73,16.73,0,0,1-3.22,1c-.66.09-1.34.08-2,.23a7.65,7.65,0,0,0-2.77,1.47,35.85,35.85,0,0,0-6.32,6.05h-.57l3.25-6.61c1.72-3.5,3.44-7,4.82-10.65a2.13,2.13,0,0,0,.19-1,.72.72,0,0,0-.7-.63,1,1,0,0,0-.47.24,25.83,25.83,0,0,0-2.95,2.58,5.66,5.66,0,0,1-2.31,1.71,2.78,2.78,0,0,1,.44-1.38l4.79-9.1c.2-.39.36-1,0-1.2s-.85.32-1,.78c-3.52,8.77-9.38,16.39-14.87,24a8.05,8.05,0,0,1-2,2.34,5.57,5.57,0,0,1,.29-1.74c.1-.26.24-.43.32-.67a125.2,125.2,0,0,1,4.69-11.82c.32-.74.76-1.41,1.09-2.15.85-2,1.71-3.91,2.68-5.83.35-.7.86-1.32,1.22-2s1.67-1.4.67-1.92-2.49,3.13-3,3.85c-1.41,2.21-3.18,4.16-4.59,6.37a49.9,49.9,0,0,0-3.86,7.87c-1.24,3-2.9,5.88-4.42,8.78-.45-1.12.26-2.75.58-3.82a33.25,33.25,0,0,1,3.38-7.55,5.42,5.42,0,0,0,1-1.68c.17-1.54-1.34-.22-1.61.41a54.76,54.76,0,0,1-5.33,9.62c-.54.8-1.42,2.61-2.52,2.72a41,41,0,0,1,2.25-5.4,11.13,11.13,0,0,0,1.29-2.49c.18-.94-.56-1-1.06-.4-2.21,2.6-3.1,6.08-5.4,8.65a18.45,18.45,0,0,1,1.92-4.69c.31-.55,1-1.25,1.06-1.89s-.49-1.09-1-.6a12.42,12.42,0,0,0-1.54,2.16l-1.69,2.41-1.58,2.25c-.21.3-1.22,2.08-1.31,1-.05-.56,1-1.68,1.26-2.12l1.56-2.4a14.34,14.34,0,0,0,1.23-2.11c.14-.33.75-1.75,0-1.42-.47.2-1.12,1.62-1.4,2-.51.79-1,1.58-1.51,2.38-1,1.55-1.91,3.11-2.77,4.71-.37.69-.86,1.67-.19,2.35s1.29,0,1.72-.56a27.33,27.33,0,0,0,1.67-2.6,4.3,4.3,0,0,1,1.59-1.88c-.24.73-1.53,4.41.25,4.34,1.43,0,.88-2.79,2.36-2.74,0,1.08.7,2.46,1.68,1.18s1.72-2.59,2.54-3.88c.17-.29.59-1.26,1-.58.2.38-.3,1.42-.36,1.83a6.27,6.27,0,0,0-.11,2c.12.61.62,1.24,1.2.64a7.32,7.32,0,0,0,.87-1.8c.3-.63.6-1.27.91-1.91,1.73-3.61,3.59-7.17,5.48-10.7.57-1.06,1.14-2.11,1.73-3.15.16-.29,1.21-2.26,1.4-2s-1,2.29-1.15,2.63c-.44.86-.9,1.75-1.28,2.65-.92,2.19-1.89,4.54-2.6,6.86-.32,1-.65,2.14-1.06,3.14a24.16,24.16,0,0,1-2,4c-1.21,1.89-2.06,4-3.19,6-.75,1.28-1.5,2.57-2.27,3.83-.57.94-1.91,2.63-1.54,3.78.26.83.76,0,1.07-.42a27.83,27.83,0,0,0,1.62-2.87c.41-.8,1-1.5,1.4-2.28,1-1.75,2.06-3.58,3.18-5.29s2.6-3.24,3.65-5a64.08,64.08,0,0,1,9.39-12.16,50.58,50.58,0,0,1,6.82-6,1.74,1.74,0,0,1-.16,1.35c-2.48,6.09-6.07,11.69-8.44,17.83a5.82,5.82,0,0,0-.56,2.94c0,.27.19.6.46.57s.33-.21.42-.39a31.25,31.25,0,0,1,8.86-10.49,6.8,6.8,0,0,1,2.42-1.31c.82-.2,1.68-.12,2.52-.25a20.11,20.11,0,0,0,4.1-1.53C2151.53,90.64,2153.81,90.45,2155.71,89.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1810.88,204a7.61,7.61,0,0,1,7.28,5.39l16.56,53.94h0a10,10,0,0,1,20,0h0a10,10,0,0,1,10-9.94h0a10,10,0,0,1,10,9.94h0l20.24-68.44a7.53,7.53,0,0,1,14.61,3.58l-12.55,64.08h0a36.27,36.27,0,0,1,21.47-6.95h1.61a5.43,5.43,0,0,1,3.82,9.28l-20.68,20.68a21.76,21.76,0,0,0-6.33,14.18l0,11.71V951.26h-84.39V266.64a36.49,36.49,0,0,0-.59-6.51l-8.6-47.11A7.62,7.62,0,0,1,1810.88,204Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1834.72,263.36l-16.56-53.94a7.61,7.61,0,0,0-7.28-5.39h0a7.62,7.62,0,0,0-7.5,9l8.6,47.11a36.49,36.49,0,0,1,.59,6.51V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1896.96,
    y1: 311.5,
    x2: 1896.96,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1874.81,263.36l20.24-68.44a7.53,7.53,0,0,1,7.22-5.39h0a7.53,7.53,0,0,1,7.39,9l-12.55,64.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1860.7,351.45A36.25,36.25,0,0,0,1897,315.19V301a21.77,21.77,0,0,1,6.37-15.39L1924,264.93a5.43,5.43,0,0,0-3.82-9.28h-1.61a36.29,36.29,0,0,0-25.77,10.62l-13.11,13.11c-2.57,2.57-5.26,5-8,7.48a37.44,37.44,0,0,0-12.31,27.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1852.86,283l1.85-18.55a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.55a8.17,8.17,0,0,0,8.12,7.35h0A8.17,8.17,0,0,0,1852.86,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1872.91,283l1.85-18.55a10,10,0,0,0-10-11h0a10,10,0,0,0-10,11l1.85,18.55a8.17,8.17,0,0,0,8.12,7.35h0A8.17,8.17,0,0,0,1872.91,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3469.36,280.21V951.26h-88.67V305l37.42-18.57A130,130,0,0,0,3469.36,280.21Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3380.69,
    y1: 951.26,
    x2: 3380.69,
    y2: 305.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3469.36,
    y1: 280.21,
    x2: 3469.36,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M3564.47,149.66a137.11,137.11,0,1,0-137.11,137.11A137.11,137.11,0,0,0,3564.47,149.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3446.83,13.94l-155.2,155.19a137.25,137.25,0,0,0,78.62,105.21L3552,92.56A137.23,137.23,0,0,0,3446.83,13.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3564.47,149.66a137,137,0,0,0-4.65-35.47L3391.89,282.13a138,138,0,0,0,60.58,2.34l109.69-109.69A137.66,137.66,0,0,0,3564.47,149.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3564.47,149.66a137.11,137.11,0,1,0-137.11,137.11A137.11,137.11,0,0,0,3564.47,149.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3456.44,120.58a41.13,41.13,0,1,0,0,58.17A41.12,41.12,0,0,0,3456.44,120.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3456.44,120.58a41.32,41.32,0,0,0-11.35-8l-54.85,54.85a41.13,41.13,0,1,0,66.2-46.81Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3427.36,
    cy: 149.66,
    r: 32.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3423.25,149.66a4.11,4.11,0,1,1,4.11,4.12A4.11,4.11,0,0,1,3423.25,149.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3459,49.28a105.73,105.73,0,0,0-63.28,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3450.37,76.66a76.86,76.86,0,0,0-46,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3512.43,64.59a120.32,120.32,0,0,0-170.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3395.72,250a105.58,105.58,0,0,0,63.28,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3404.35,222.67a76.86,76.86,0,0,0,46,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M3342.29,234.73a120.3,120.3,0,0,0,170.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3327,118a105.61,105.61,0,0,0,0,63.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3354.35,126.65a76.9,76.9,0,0,0,0,46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3362.72,85a91.4,91.4,0,0,0,0,129.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3527.74,181.31a105.77,105.77,0,0,0,0-63.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3500.36,172.68a76.9,76.9,0,0,0,0-46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3492,214.31A91.41,91.41,0,0,0,3492,85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3420.8,345.14A40.1,40.1,0,0,1,3380.69,305V272.89a24,24,0,0,1,7-17l29.35-29.36a6,6,0,0,1,10.27,4.26v2.06a40.11,40.11,0,0,1-11.75,28.36l-6.92,6.92a4,4,0,0,0,.08,5.75,41.4,41.4,0,0,1,13.42,30.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3420.8,345.14A40.1,40.1,0,0,1,3380.69,305V272.89a24,24,0,0,1,7-17l29.35-29.36a6,6,0,0,1,10.27,4.26v2.06a40.11,40.11,0,0,1-11.75,28.36l-6.92,6.92a4,4,0,0,0,.08,5.75,41.4,41.4,0,0,1,13.42,30.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M908.64,220.42,832.4,144.18l-15.2,15.2a7.81,7.81,0,0,1-11.05,11.05L791,185.63l12.93,12.93,1.55-5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M922.37,284.79,927.94,264a7.82,7.82,0,1,1,4-15.1l5.56-20.76-132.11-35.4-5.56,20.76a7.82,7.82,0,1,1-4,15.1l-5.56,20.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M824.28,262.36h0A10.81,10.81,0,0,0,817,276.62l3,8h0V951.26h84.79V307.11q0-18.37-1.72-36.69l-1.58-16.75A48.6,48.6,0,0,1,902,241l1.66-9.71a5.86,5.86,0,0,0-5.78-6.85h0a18.87,18.87,0,0,0-18.6,15.7h0a48.21,48.21,0,0,0-.29,14.39l2.43,18.63a7.61,7.61,0,0,1,0,1.43l-7.73-2.36h0l-12.24-3.75.08.21-3.33-1,0-.13L848.71,265h0l-13.48-3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M908.64,220.42,832.4,144.18l-15.2,15.2a7.81,7.81,0,0,1-11.05,11.05L791,185.63l12.93,12.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 819.99,
    y1: 284.6,
    x2: 819.99,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M835.81,263.47l7.11,18.79a8.79,8.79,0,0,0,10.5,5.38h0a8.79,8.79,0,0,0,6.4-9.91l-1.66-10.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M861.43,268.46l3.06,8.09A8.85,8.85,0,0,0,875.07,282h0a8.81,8.81,0,0,0,4.08-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M841,290.88l-3.25-19.83a10.8,10.8,0,0,0-13.45-8.69h0A10.81,10.81,0,0,0,817,276.62l7.11,18.79a8.78,8.78,0,0,0,10.49,5.38h0A8.8,8.8,0,0,0,841,290.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M859.07,348.81A39.08,39.08,0,0,1,820,309.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M908.64,220.42,832.4,144.18l-15.2,15.2a7.81,7.81,0,0,1-11.05,11.05L791,185.63l12.93,12.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 860.03,
    y1: 182.87,
    x2: 840.68,
    y2: 202.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 901.26,
    y1: 248.79,
    x2: 914.86,
    y2: 252.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 850.69,
    y1: 235.24,
    x2: 878.85,
    y2: 242.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 848.71,
    y1: 212.45,
    x2: 837.58,
    y2: 253.98
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "878.99 212.48 860.23 193.72 862.44 191.51 885.03 214.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "865.15 208.77 855.16 198.78 857.38 196.57 871.19 210.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "819.02 196.41 811.88 189.27 814.09 187.06 825.15 198.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "903.54 231.71 919.28 235.93 918.47 238.95 903.01 234.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "884.57 229.86 854.3 221.75 855.11 218.74 887.59 227.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "902.33 238.8 917.43 242.85 916.62 245.87 901.8 241.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "880.36 236.15 852.45 228.68 853.26 225.66 881.81 233.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "879.75 260.71 846.27 251.74 847.08 248.72 879.31 257.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "902.41 263.55 911.25 265.92 910.44 268.94 902.72 266.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 810.27,
    y: 241.59,
    width: 19.96,
    height: 3.13,
    transform: "translate(1549.62 690.32) rotate(-165)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "878.77 253.03 848.12 244.82 848.93 241.8 878.56 249.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "901.69 255.94 913.1 259 912.29 262.02 902 259.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M865.92,309.73a40.34,40.34,0,0,1,13-29.91,7.76,7.76,0,0,0,2.48-6.68l-2.43-18.63a48.21,48.21,0,0,1,.29-14.39h0a18.87,18.87,0,0,1,18.6-15.7h0a5.86,5.86,0,0,1,5.78,6.85L902,241a48.59,48.59,0,0,0-.47,12.69l1.58,16.75q1.73,18.3,1.72,36.69V951.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M903.83,279.82l18.54,5L927.94,264a7.82,7.82,0,1,1,4-15.1l5.56-20.76-132.11-35.4-5.56,20.76a7.82,7.82,0,1,1-4,15.1l-5.56,20.76,91.16,24.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M826,216.11l13,3.48a4.81,4.81,0,0,0-3.41-5.89L821.67,210a4.82,4.82,0,0,0-5.89,3.41l5.58,1.49-1,3.72-5.58-1.5-.75,2.8,5.58,1.5-1,3.71L813,223.6l-.76,2.8,5.59,1.5-1,3.73-5.59-1.49a4.82,4.82,0,0,0,3.41,5.89l13.94,3.74a4.83,4.83,0,0,0,5.89-3.4l-13-3.49,1-3.74,13,3.49.75-2.78-13-3.49,1-3.74,13,3.49.75-2.78-13-3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M838.59,174.62l9.61,9.6a4.85,4.85,0,0,0,0-6.86l-10.3-10.3a4.88,4.88,0,0,0-6.86,0l4.12,4.13-2.74,2.74-4.13-4.12-2.07,2.07,4.13,4.12-2.75,2.74-4.12-4.12-2.07,2.07,4.12,4.12-2.76,2.76-4.12-4.12a4.86,4.86,0,0,0,0,6.86l10.3,10.3a4.86,4.86,0,0,0,6.86,0l-9.6-9.61,2.76-2.76,9.6,9.61,2-2-9.6-9.61,2.76-2.76,9.6,9.61,2.06-2-9.61-9.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 4539.6,
    y: 161.99,
    width: 14.9,
    height: 12.41,
    transform: "translate(9094.09 336.39) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M4539.6,184.06V174.4h27.31v18.68c-.07-.28-18.15-8.59-18.15-8.59A11.48,11.48,0,0,0,4539.6,184.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4536.43,230.25l9.91.39v-.07l-9.91-.44a11.92,11.92,0,1,1,3.42-23.48l11.36,2.83v0l-10.44-2.59a11.92,11.92,0,0,1-8.36-15.57h0a11.92,11.92,0,0,1,16.33-6.78l18.15,8.59v-9.74l18.34,7.89h0a43.17,43.17,0,0,1-10.45-28.14v-2.22a6.47,6.47,0,0,1,11-4.58l31.57,31.57a25.91,25.91,0,0,1,7.58,18.3v34.57c0,.78,0,1.54-.06,2.31l.06,708.22h-85.54V274.18l0-.22a10.35,10.35,0,0,1,.23-20.33l-1.87.3a11.92,11.92,0,1,1-1.42-23.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4558.93,250.53l-19,3.06a10.36,10.36,0,0,0-8.37,12.88h0a10.35,10.35,0,0,0,13.64,7l18-6.77a8.43,8.43,0,0,0,5.19-10.05h0A8.44,8.44,0,0,0,4558.93,250.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4558.58,231.12l-22.15-.87a11.93,11.93,0,0,0-12.38,12.63h0a11.93,11.93,0,0,0,13.8,11.05l21.9-3.53a9.71,9.71,0,0,0,8.14-10.17h0A9.71,9.71,0,0,0,4558.58,231.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4562.32,212.17l-21.53-5.33a11.92,11.92,0,0,1-8.36-15.57h0a11.92,11.92,0,0,1,16.33-6.78l20,9.49a9.69,9.69,0,0,1,5,12h0A9.7,9.7,0,0,1,4562.32,212.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4558.6,231.12l-22.16-1a11.93,11.93,0,0,1-11.26-13.63h0a11.92,11.92,0,0,1,14.68-9.85l21.52,5.36a9.7,9.7,0,0,1,7.25,10.81h0A9.69,9.69,0,0,1,4558.6,231.12Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4539.46,
    y1: 274.18,
    x2: 4539.46,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "4566.91 193.08 4566.91 174.4 4539.6 174.4 4539.6 184.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4539.6,
    y: 161.99,
    width: 14.9,
    height: 12.41,
    transform: "translate(9094.09 336.39) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 4561.94,
    y: 170.93,
    width: 4.97,
    height: 3.48,
    transform: "translate(9128.85 345.33) rotate(-180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4539.6,
    y1: 168.2,
    x2: 4547.05,
    y2: 168.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4566.91,
    y1: 183.34,
    x2: 4585.25,
    y2: 191.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4551.21,131.87l-1.9,5.69a1,1,0,0,1-1.92-.15l-2.49-14.2-5.44,21.47a7.82,7.82,0,1,0,15.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4127.21,248.6h0a7.61,7.61,0,0,1,7.27,5.37L4151,307.8h0a10,10,0,0,1,10-9.91h0a10,10,0,0,1,9.95,11l-.28,2.82,2.32.46.32-2a10,10,0,1,1,19.23,5.15l-.25.65,1.65.33a10,10,0,0,1,14.12-4.55h0a10,10,0,0,1,3.12,14.5l-1,1.42,12-6.95a36.2,36.2,0,0,1,27.59-3.58l1.55.42a5.43,5.43,0,0,1,1.29,9.94l-25.28,14.59a21.73,21.73,0,0,0-10.11,13.18L4213.57,369a36.2,36.2,0,0,1-2.56,6.78h0V951.26h-82.12V311.07a36.26,36.26,0,0,0-.58-6.49l-8.58-47A7.6,7.6,0,0,1,4127.21,248.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4151,307.8,4134.48,254a7.61,7.61,0,0,0-7.27-5.37h0a7.6,7.6,0,0,0-7.48,9l8.58,47a36.26,36.26,0,0,1,.58,6.49V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4211.01,
    y1: 375.74,
    x2: 4211.01,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4169.25,394.55A36.18,36.18,0,0,0,4213.57,369l3.67-13.68a21.73,21.73,0,0,1,10.11-13.18l25.28-14.59a5.43,5.43,0,0,0-1.29-9.94l-1.55-.42a36.2,36.2,0,0,0-27.59,3.58l-14,8.1c-3,1.73-7.91,4.49-11,6a37.33,37.33,0,0,0-19.62,23.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4169.1,327.39l1.85-18.51a10,10,0,0,0-9.95-11h0a10,10,0,0,0-9.95,11l1.85,18.51a8.14,8.14,0,0,0,8.1,7.34h0A8.15,8.15,0,0,0,4169.1,327.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4186,332.73l6.58-17.4a10,10,0,0,0-6.77-13.19h0a10,10,0,0,0-12.46,8l-3,18.36a8.14,8.14,0,0,0,5.93,9.18h0A8.14,8.14,0,0,0,4186,332.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4210.16,327.68l1-1.42a10,10,0,0,0-3.12-14.5h0a10,10,0,0,0-14.12,4.55l-7.65,17a8.14,8.14,0,0,0,1.06,8.43"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2535.14,
    y: 108.47,
    width: 106.37,
    height: 70.91,
    transform: "translate(50.94 674.81) rotate(-15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2621,180.36a9.8,9.8,0,0,1,10.44-3.66h0a9.8,9.8,0,0,1,6.63,12.93l-2.74,7.25V951.26h-76.93v-734q0-16.68,1.56-33.29l1.44-15.2a43.94,43.94,0,0,0-.44-11.51l-1.5-8.82a5.31,5.31,0,0,1,5.24-6.21,17.12,17.12,0,0,1,16.88,14.24h0a43.66,43.66,0,0,1,.26,13.06L2580.12,183h0l41.21-11.22a9.77,9.77,0,0,1-.33,5.91l-.83,2.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2635.36,
    y1: 196.88,
    x2: 2635.36,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2621.33,171.79a9.77,9.77,0,0,1-.33,5.91l-6.44,17.05a8,8,0,0,1-9.53,4.88h0a8,8,0,0,1-5.81-9l2.21-13.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2598.42,177.93l-.3,3a8,8,0,0,1-7.94,7.18h0a8,8,0,0,1-7.7-5.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2616.32,202.57l2.94-18a9.8,9.8,0,0,1,12.21-7.88h0a9.8,9.8,0,0,1,6.63,12.93l-6.45,17.05a8,8,0,0,1-9.52,4.88h0A8,8,0,0,1,2616.32,202.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2599.9,255.13a35.46,35.46,0,0,0,35.46-35.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "2580.15 182.83 2648.87 164.41 2630.52 95.92 2527.77 123.44 2546.13 191.94 2559.61 188.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2548.32,
    y1: 117.94,
    x2: 2561.54,
    y2: 167.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2588.67,
    y1: 114.47,
    x2: 2603.35,
    y2: 169.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2635.36,331.46h0a3.86,3.86,0,0,1-1.28,7.5h0a76.19,76.19,0,0,1-73.79-57.21l-31.37-121.92L2558.43,229"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2547.23,
    cy: 154.94,
    r: 3.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2609.76,165.48l-2-7.26L2625.3,151c2.29-.94,3.91-1.47,5.61-2l0-.21c-1.76.39-3.42.75-5.87,1.1l-18.76,2.66-2-7.22,31.47-2.58,2.44,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2633.69,135.21l-30,8.15-1.92-7,29.95-8.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2603.72,112l2.45-.66c5.61-1.53,9.5.77,11.08,6.59l.62,2.28,10.93-3,1.92,7-30,8.15-2.49-9.15C2596.64,117.28,2598.5,113.47,2603.72,112Zm2.16,7.26c-2.41.65-3.17,1.67-2.68,3.49l.37,1.35,9.45-2.57-.37-1.35c-.49-1.82-1.79-2.28-4.62-1.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 2556.46,
    y: 143.45,
    width: 56.73,
    height: 2.84,
    transform: "matrix(0.26, 0.97, -0.97, 0.26, 2055.75, -2389.38)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "2572.66 144.21 2566.29 120.47 2563.55 121.2 2569.37 142.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "2565.41 142.28 2560.01 122.15 2557.28 122.88 2562.59 142.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2577.46,147.94a17,17,0,0,1,4.15,8.57h0a43.38,43.38,0,0,1,.59,9.17h0l2.32,8.63,2.74-.73-14.69-54.8-2.74.74,7.61,28.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2547.91,157.51l-1.37-5.14-1.16.87a5.93,5.93,0,0,1-4.25,1.14h0a5.93,5.93,0,0,0-2.8.34l-10.81,4.09a1.37,1.37,0,0,0-.84,1.64h0a1.36,1.36,0,0,0,1.54,1l11.41-1.86a6.07,6.07,0,0,0,2.6-1.1h0a5.85,5.85,0,0,1,4.24-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2593.69,219.67a36.59,36.59,0,0,0-11.77-27.13,7,7,0,0,1-2.25-6.06l2.2-16.91a43.66,43.66,0,0,0-.26-13.06h0a17.12,17.12,0,0,0-16.88-14.24h0a5.31,5.31,0,0,0-5.24,6.21l1.5,8.82a43.94,43.94,0,0,1,.44,11.51L2560,184q-1.56,16.59-1.56,33.29v734"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2721.26,236.18a7.59,7.59,0,0,0-7.27,5.37l-16.52,53.83h0a10,10,0,0,0-19.65-2.53l-.73-.09a10.85,10.85,0,0,0-.51-1.42,36.17,36.17,0,0,0,.89-7.93v-1.86a5.43,5.43,0,0,0-9.27-3.84L2655.88,290h0l-18.62-62.95a7.51,7.51,0,0,0-14.57,3.57l12,61.28a36.09,36.09,0,0,1,.68,7V951.26h84.21V298.65a36.18,36.18,0,0,1,.59-6.49l8.58-47A7.59,7.59,0,0,0,2721.26,236.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2697.47,295.38,2714,241.55a7.59,7.59,0,0,1,7.27-5.37h0a7.59,7.59,0,0,1,7.48,9l-8.58,47a36.18,36.18,0,0,0-.59,6.49V951.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2655.88,290l-18.62-62.95a7.5,7.5,0,0,0-7.2-5.38h0a7.51,7.51,0,0,0-7.37,9l12,61.28a36.09,36.09,0,0,1,.68,7V951.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2671.54,384.73a36.18,36.18,0,0,1-36.18-36.18v-29a21.75,21.75,0,0,1,6.36-15.36l26.48-26.48a5.43,5.43,0,0,1,9.27,3.84v1.86a36.22,36.22,0,0,1-10.6,25.59l-6.25,6.24a3.6,3.6,0,0,0,.08,5.19A37.34,37.34,0,0,1,2672.8,348"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2679.37,315l-1.85-18.51a10,10,0,0,1,9.95-11h0a10,10,0,0,1,10,11L2695.57,315a8.15,8.15,0,0,1-8.1,7.33h0A8.14,8.14,0,0,1,2679.37,315Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2676.56,291.3a10,10,0,0,1,.86,5.16L2675.56,315a8.13,8.13,0,0,1-8.1,7.33h0a8.13,8.13,0,0,1-7.73-5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3382.37,183.46h0a7.59,7.59,0,0,0-7.26,5.38l-16.53,53.82h0a10,10,0,0,0-10-9.91h0a10,10,0,0,0-9.95,11l.28,2.81-2.32.46-.32-2A10,10,0,1,0,3317,250.2l.25.65-1.65.33a10,10,0,0,0-14.12-4.55h0a10,10,0,0,0-3.12,14.5l1,1.42-12-7a36.2,36.2,0,0,0-27.59-3.58l-1.55.42a5.43,5.43,0,0,0-1.29,9.94L3282.23,277a21.75,21.75,0,0,1,10.11,13.19l3.67,13.68a36.11,36.11,0,0,0,2.56,6.77h0V951.26h82.12V245.94a35.48,35.48,0,0,1,.59-6.5l8.57-47A7.6,7.6,0,0,0,3382.37,183.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3358.58,242.66l16.53-53.82a7.59,7.59,0,0,1,7.26-5.38h0a7.6,7.6,0,0,1,7.48,9l-8.57,47a35.48,35.48,0,0,0-.59,6.5V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3298.57,
    y1: 310.61,
    x2: 3298.57,
    y2: 951.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3340.33,329.41A36.18,36.18,0,0,1,3296,303.83l-3.67-13.68A21.75,21.75,0,0,0,3282.23,277L3257,262.37a5.43,5.43,0,0,1,1.29-9.94l1.55-.42a36.2,36.2,0,0,1,27.59,3.58l14,8.11c3,1.72,7.9,4.48,11,6A37.35,37.35,0,0,1,3332,293.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3340.48,262.26l-1.85-18.51a10,10,0,0,1,9.95-11h0a10,10,0,0,1,10,11l-1.85,18.51a8.14,8.14,0,0,1-8.1,7.33h0A8.15,8.15,0,0,1,3340.48,262.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3323.62,267.6,3317,250.2a10,10,0,0,1,6.77-13.2h0a10,10,0,0,1,12.46,8.05l3,18.36a8.13,8.13,0,0,1-5.93,9.17h0A8.13,8.13,0,0,1,3323.62,267.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3299.42,262.55l-1-1.42a10,10,0,0,1,3.12-14.5h0a10,10,0,0,1,14.12,4.55l7.65,16.95a8.14,8.14,0,0,1-1.06,8.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1567,190.7a7.3,7.3,0,0,1,7.06,5.45l12.07,45.94a.07.07,0,0,0,.14,0l-.73-58.29a7.46,7.46,0,0,1,7.47-7.56h0a7.47,7.47,0,0,1,7.39,6.4l8.52,59.34a.08.08,0,0,0,.15,0l4.22-66.1a7.35,7.35,0,0,1,14.68.26l1.84,65.94a.08.08,0,0,0,.15,0l13-60.14a7.25,7.25,0,0,1,7.09-5.71h0a7.24,7.24,0,0,1,7.19,8.12l-6.82,56.14a37.5,37.5,0,0,0-.26,4.36v2.23a36.14,36.14,0,0,1,21.56-7h1.61a5.43,5.43,0,0,1,3.82,9.27L1656.47,270a21.71,21.71,0,0,0-6.36,15.35v14.16h0V951.26H1565.9v-706a35.91,35.91,0,0,0-.36-5.07L1559.73,199A7.29,7.29,0,0,1,1567,190.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1650.11,247.06v-2.21a37.5,37.5,0,0,1,.26-4.36l6.82-56.14a7.24,7.24,0,0,0-7.19-8.12h0a7.25,7.25,0,0,0-7.09,5.71l-13,60.14a.08.08,0,0,1-.15,0l-1.84-65.94a7.34,7.34,0,0,0-7.34-7.14h0a7.35,7.35,0,0,0-7.34,6.88L1609,242a.08.08,0,0,1-.15,0l-8.52-59.34a7.47,7.47,0,0,0-7.39-6.4h0a7.46,7.46,0,0,0-7.47,7.56l.73,58.29a.07.07,0,0,1-.14,0L1574,196.15a7.3,7.3,0,0,0-7.06-5.45h0a7.29,7.29,0,0,0-7.22,8.32l5.81,41.12a35.91,35.91,0,0,1,.36,5.07V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1650.11,
    y1: 951.26,
    x2: 1650.11,
    y2: 299.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1613.92,335.66a36.19,36.19,0,0,0,36.19-36.19V285.31a21.71,21.71,0,0,1,6.36-15.35l20.64-20.64a5.43,5.43,0,0,0-3.82-9.27h-1.61a36.17,36.17,0,0,0-25.72,10.6l-13.07,13.07c-2.57,2.57-5.25,5-7.94,7.47a37.33,37.33,0,0,0-12.28,27.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M988,262.87a7.31,7.31,0,0,1,7.06,5.45l12.06,45.95a.07.07,0,0,0,.14,0l-.73-58.29a7.47,7.47,0,0,1,7.47-7.56h0a7.47,7.47,0,0,1,7.39,6.41l8.53,59.34a.07.07,0,0,0,.14,0l4.23-66.1a7.34,7.34,0,0,1,14.67.26l1.85,65.94a.07.07,0,0,0,.14,0l13-60.13a7.25,7.25,0,0,1,7.09-5.72h0a7.25,7.25,0,0,1,7.2,8.12l-6.82,56.14a35.48,35.48,0,0,0-.27,4.37v2.2l0,0a36.18,36.18,0,0,1,21.56-7h1.6a5.42,5.42,0,0,1,3.82,9.26l-20.64,20.64a21.71,21.71,0,0,0-6.36,15.35v14.16h0V951.26H986.9V317.38a35.77,35.77,0,0,0-.36-5.06l-5.81-41.12A7.31,7.31,0,0,1,988,262.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1071.11,319.23V317a35.48,35.48,0,0,1,.27-4.37l6.82-56.14a7.25,7.25,0,0,0-7.2-8.12h0a7.25,7.25,0,0,0-7.09,5.72l-13,60.13a.07.07,0,0,1-.14,0l-1.85-65.94a7.34,7.34,0,0,0-7.34-7.14h0a7.34,7.34,0,0,0-7.33,6.88l-4.23,66.1a.07.07,0,0,1-.14,0l-8.53-59.34a7.47,7.47,0,0,0-7.39-6.41h0a7.47,7.47,0,0,0-7.47,7.56l.73,58.29a.07.07,0,0,1-.14,0L995,268.32a7.31,7.31,0,0,0-7.06-5.45h0a7.31,7.31,0,0,0-7.23,8.33l5.81,41.12a35.77,35.77,0,0,1,.36,5.06V951.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1071.11,
    y1: 951.26,
    x2: 1071.11,
    y2: 371.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1034.93,407.83a36.18,36.18,0,0,0,36.18-36.19V357.48a21.71,21.71,0,0,1,6.36-15.35l20.64-20.64a5.42,5.42,0,0,0-3.82-9.26h-1.6a36.19,36.19,0,0,0-25.72,10.6l-13.08,13.08c-2.57,2.57-5.25,5-7.94,7.47a37.35,37.35,0,0,0-12.28,27.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.22,249.76a37,37,0,0,0,10.89-26.3V221.6a6.43,6.43,0,0,0-11-4.55l-9.87,9.87-5.78-58.3A8.73,8.73,0,0,0,.05,165.46v92.83c0,.43,0,.87,0,1.31v29c0,.5,0,1,0,1.51L0,952.26a1,1,0,0,0,1-1l.05-650.51a37.25,37.25,0,0,0,35.14,25,1,1,0,0,0,0-2A35.22,35.22,0,0,1,1.05,290.47v-32a20.57,20.57,0,0,1,6-13.55l26.48-26.48a4.43,4.43,0,0,1,7.56,3.13v1.86A34.93,34.93,0,0,1,30.8,248.34l-6.24,6.25A4.66,4.66,0,0,0,23.19,258a4.53,4.53,0,0,0,1.47,3.25,36.52,36.52,0,0,1,11.78,26.83,1,1,0,0,0,2,0A38.56,38.56,0,0,0,26,259.74a2.54,2.54,0,0,1-.82-1.82A2.63,2.63,0,0,1,26,256ZM5.65,243.54a22.85,22.85,0,0,0-4.6,6.65V169.48a6.73,6.73,0,0,1,13.43-.66l6,59.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4624.94,243c0-.77.06-1.53.06-2.31V198.88a26.72,26.72,0,0,0-6.87-11.72l-31.57-31.57a7.48,7.48,0,0,0-12.76,5.28v2.22a43.88,43.88,0,0,0,12.93,31.21l7.45,7.44a3.34,3.34,0,0,1,1,2.43,3.21,3.21,0,0,1-1,2.31,45.75,45.75,0,0,0-14.75,33.6,1,1,0,0,0,2,0,43.8,43.8,0,0,1,14.1-32.13,5.17,5.17,0,0,0,1.69-3.73,5.34,5.34,0,0,0-1.57-3.89l-7.44-7.45a41.85,41.85,0,0,1-12.35-29.79v-2.22a5.48,5.48,0,0,1,9.34-3.87l31.57,31.57a24.72,24.72,0,0,1,7.29,17.59v33.18a1.07,1.07,0,0,0-.06.31V243a42.19,42.19,0,0,1-42.08,39.88,1,1,0,0,0,0,2,44.22,44.22,0,0,0,42.08-30.81l.06,697.2a1,1,0,0,0,1,1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsBack);
export default __webpack_public_path__ + "static/media/hands_back.ba759b64701328be3a9d99d1d8317c20.svg";
export { ForwardRef as ReactComponent };